// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/boxicons/css/boxicons.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/bootstrap-icons/font/bootstrap-icons.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/blockchainhigh.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/about/BG12.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/about/trade.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/about/pexels-303.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/about/BG30.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../img/service/BG3.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../img/footer-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../img/service/BG21.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../img/career/career.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../img/contact/contact.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../img/hnh-logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/*--------------------------------------------------------------
# General
--------------------------------------------------------------*/

:root {
  --primaryColor: #DA251C;
}
body {
  /* font-family: "Open Sans", sans-serif; */
  font-family: 'Archivo', sans-serif;
  /* color: #444444; */
}

a {
  text-decoration: none;
  color: var(--primaryColor);
}

a:hover {
  color: #0b0909;
  text-decoration: none;

}

/* h1,
h2,
h3,
h4,
h5,
h6{
  font-family: "Archivo", sans-serif;
}
p {
  font-family: "Archivo", sans-serif;
  font-size: 20px;
} */
/* Base font size variable */
/* Base font size variable */
:root {
  --base-font-size: 20px!important; 
}


h1, h2, h3, h4, h5, h6 {
  font-family: "Archivo", sans-serif;
}

p {
  font-family: "Archivo", sans-serif;
  font-size: 1rem; 
}

@media (max-width: 768px) {
  h1 {
    font-size: calc(var(--base-font-size) * 2.7)!important; 
  }

  h2 {
    font-size: calc(var(--base-font-size) * 2.2)!important; 
  }

  h3 {
    font-size: calc(var(--base-font-size) * 1.7)!important; 
  }
  h4 {
    font-size: calc(var(--base-font-size) * 1.2)!important; 
  }
}

@media (max-width: 480px) {
  h1 {
    font-size: calc(var(--base-font-size) * 2.5)!important; 
  }
  h3 {
    font-size: calc(var(--base-font-size) * 1.5)!important; 
  }
  h4 {
    font-size: calc(var(--base-font-size) * 1)!important; 
  }  
}

.logo-container {
  width: 100%; 
  height: auto; 
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
}

.img-fluid {
  max-width: 100%;
  max-height: 100%;
  background-color: transparent;
}

/*--------------------------------------------------------------
# Disable AOS delay on mobile
--------------------------------------------------------------*/
@media screen and (max-width: 768px) {
  [data-aos-delay] {
    transition-delay: 0 !important;
  }
}

/*--------------------------------------------------------------
# Top Bar
--------------------------------------------------------------*/
#topbar {
  background: #1c1c1c;
  padding: 10px 0;
  font-size: 14px;
  color: #9b9b9b;
}

#topbar .contact-info i {
  font-style: normal;
  color: var(--primaryColor);
}

#topbar .contact-info i a,
#topbar .contact-info i span {
  padding-left: 5px;
  color: #fff;
}

#topbar .contact-info i a {
  line-height: 0;
  transition: 0.3s;
}

#topbar .contact-info i a:hover {
  color: var(--primaryColor);
}

#topbar .social-links a {
  color: #9b9b9b;
  line-height: 0;
  transition: 0.3s;
  margin-left: 10px;
}

#topbar .social-links a:hover {
  color: white;
}

.social {
  display: flex;
  gap: 16px;
  margin-top: 16px;
  font-size: 20px;
}
.social i:hover {
  font-size: 22px;
  transition: 100ms ease;
  color: whitesmoke;
}


/*--------------------------------------------------------------
# Header
--------------------------------------------------------------*/
#header {
  height: 70px;
  transition: all 0.5s;
  z-index: 997;
  transition: all 0.5s;
  background: #0f0f0f;
  position: sticky;
  top: 0px;
  /* opacity: 0.8; */
}

#header .logo h1 {
  /* font-size: 28px; */
  margin: 0;
  padding: 11px 0;
  line-height: 1;
  font-weight: 700;
  letter-spacing: 1px;
  font-family: "Archivo", sans-serif;
}

#header .logo h1 a,
#header .logo h1 a:hover {
  color: var(--primaryColor);
  text-decoration: none;
}

#header .logo img {
  padding: 0;
  margin: 0;
  max-height: 68px;
}

.scrolled-offset {
  margin-top: 70px;
}
.navbar .navbar-brand {
  font-size: 30px;
}
.navbar-brand {
  font-size: 2.5rem!important;
}
.navbar .nav-item {
  padding: 10px 20px;
}
.navbar .nav-links {
  font-size: 16px;
  margin-left: 10px;
}
.nav-links.active {
  color: red!important;
}
.navbar-toggler {
  border: none!important;
}

.navbar-small {
  height: 50px;
}

.navbar-collapse {
  transition: max-height 0.3s ease;
  overflow: hidden;
}

.navbar-collapse.show {
  max-height: 500px;
}



.fa-bars {
  color: #007bff;
  font-size: 30px;
}
/*--------------------------------------------------------------
# Navigation Menu
--------------------------------------------------------------*/
/**
* Desktop Navigation 
*/
.navbar {
  padding: 0;
}

.navbar ul {
  margin: 0;
  padding: 0;
  display: flex;
  list-style: none;
  align-items: center;
}

.navbar li {
  position: relative;
}

.navbar a,
.navbar a:focus {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0 10px 30px;
  font-family: "Archivo", sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  text-transform: uppercase;
  white-space: nowrap;
  transition: 0.3s;
  text-decoration: none
}

.navbar a i,
.navbar a:focus i {
  font-size: 12px;
  line-height: 0;
  margin-left: 5px;
}

.navbar a:hover,
.navbar .active,
.navbar .active:focus,
.navbar li:hover>a {
  color: var(--primaryColor);
}


/**
* Mobile Navigation 
*/
.mobile-nav-toggle {
  color: #fff;
  font-size: 28px;
  cursor: pointer;
  display: none;
  line-height: 0;
  transition: 0.5s;
}

@media (max-width: 991px) {
  .mobile-nav-toggle {
    display: block;
  }

  .navbar ul {
    display: none;
  }
}

.navbar-mobile {
  position: fixed;
  overflow: hidden;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(28, 28, 28, 0.9);
  transition: 0.3s;
  z-index: 999;
}

.navbar-mobile .mobile-nav-toggle {
  position: absolute;
  top: 16px;
  right: 16px;
}

.navbar-mobile ul {
  display: block;
  position: absolute;
  top: 55px;
  right: 16px;
  bottom: 16px;
  left: 16px;
  padding: 10px 0;
  border-radius: 8px;
  background-color: #fff;
  overflow-y: auto;
  transition: 0.3s;
}

.navbar-mobile a,
.navbar-mobile a:focus {
  padding: 10px 20px;
  font-size: 16px;
  color: #353535;
}

.navbar-mobile a:hover,
.navbar-mobile .active,
.navbar-mobile li:hover>a {
  color: var(--primaryColor);
}

#hero {
  position: relative;
  width: 100%;
  height: 80vh;
  overflow: hidden;
}

#hero:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: 
    linear-gradient(90deg, rgb(3 10 9/50%), rgb(255 0 0 / 70%)),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/cover fixed; 
  z-index: -1;
  opacity: 0.8;
  transition: opacity 0.5s ease;
}

#hero .hero-container {
  position: absolute;
  background: rgba(0, 0, 0, 0.6);
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  padding: 0 16px;
}


#hero h1 {
  margin: 0 0 10px 0;
  /* font-size: 48px; */
  font-weight: 700;
  line-height: 56px;
  color: #fff;
}

#hero h5 {
  color: #eee;
  margin-bottom: 20px;
  /* font-size: 24px; */
}

.btn-get-started {
  font-family: "Archivo", sans-serif;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 1px;
  display: inline-block;
  padding: 8px 28px;
  border-radius: 50px;
  transition: 0.5s;
  margin: 10px;
  border: 2px solid var(--primaryColor);
  color: #fff;
  text-decoration: none;
}

.btn-get-started:hover {
  background: var(--primaryColor);
}

.btn-button {
  font-weight: 500!important;
  font-size: 16px!important;
  letter-spacing: 1px!important;
  display: inline-block!important;
  padding: 8px 28px!important;
  border-radius: 50px!important;
  transition: 0.5s!important;
  margin: 10px!important;
  border: 2px solid var(--primaryColor)!important;
  color: var(--primaryColor)!important;
  text-decoration: none!important;
  background-color: white!important;
}

.btn-button:hover {
  background: var(--primaryColor)!important;
  color: white!important;
}

@media (min-width: 1024px) {
  #hero {
    background-attachment: scroll;
  }
  .box-heading {
    text-align: center;
  }

}

@media (max-width: 768px) {
  #hero {
    height: 100vh;
  }

  #hero h1 {
    /* font-size: 28px; */
    line-height: 36px;
  }

  #hero h2 {
    /* font-size: 18px; */
    line-height: 24px;
    margin-bottom: 30px;
  }
  .box-heading {
    text-align: center;
  }
  .navbar .nav-links {
    font-size: 16px;
    margin: 10px;
  }
}

/*--------------------------------------------------------------
# Sections General
--------------------------------------------------------------*/
section {
  padding: 40px 0;
  overflow: hidden;
}

.section-title {
  text-align: center;
  padding-bottom: 30px;
}

.section-title h2 {
  /* font-size: 28px; */
  letter-spacing: 1px;
  font-weight: 700;
  padding: 8px 20px;
  margin: 0;
  background: #e49d913b;
  color: var(--primaryColor);
  display: inline-block;
  text-transform: uppercase;
  border-radius: 50px;
}

.section-title h3 {
  margin: 16px 0 0 0;
  font-size: 32px;
  font-weight: 700;
}

.section-title h3 span {
  color: var(--primaryColor);
}

.section-title p {
  margin: 16px auto 0 auto;
  /* font-weight: 600; */
}

@media (min-width: 1024px) {
  .section-title p {
    width: 100%;
  }
}

/*--------------------------------------------------------------
# About
--------------------------------------------------------------*/
.about .box-heading h4 {
  font-size: 28px;
  letter-spacing: 1px;
  font-weight: 700;
  padding: 8px 20px;
  margin: 0 0 16px 0;
  background: #e49d913b;
  color: var(--primaryColor);
  display: inline-block;
  text-transform: uppercase;
  border-radius: 50px;
}

.about .box-heading h3 {
  font-size: 28px;
  font-weight: 700;
  color: #353535;
  margin-bottom: 16px;
}

.about .icon-box {
  margin-top: 40px;
}

.about .icon-box .icon {
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border: 2px solid #e49d913b;
  border-radius: 50px;
  transition: 0.5s;
}

.about .icon-box .icon i {
  color: var(--primaryColor);
  font-size: 32px;
}

.about .icon-box:hover .icon {
  background: var(--primaryColor);
  border-color: var(--primaryColor);
}

.about .icon-box:hover .icon i {
  color: #fff;
}

.about .icon-box .title {
  margin-left: 85px;
  font-weight: 700;
  margin-bottom: 10px;
  font-size: 18px;
}

.about .icon-box .title a {
  color: #343a40;
  transition: 0.3s;
}

.about .icon-box .title a:hover {
  color: var(--primaryColor);
}

.about .icon-box .description {
  /* margin-left: 66px; */
  line-height: 1.4em;
  font-size: 1.3em;
  color: black;
}

.video-box-first {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center center no-repeat;
  background-size: cover;
  min-height: 350px;
  /* box-shadow: 0 0 20px rgb(0 0 0 / 70%); */
}
.video-box-second {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center center no-repeat;
  background-size: cover;
  min-height: 350px;
  /* box-shadow: 0 0 20px rgb(0 0 0 / 70%); */
}
.video-box-third {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) center center no-repeat;
  background-size: cover;
  min-height: 350px;
  /* box-shadow: 0 0 20px rgb(0 0 0 / 70%); */
}

.about .play-btn {
  width: 94px;
  height: 94px;
  background: radial-gradient(var(--primaryColor) 50%, rgba(143, 192, 78, 0.4) 52%);
  border-radius: 50%;
  display: block;
  position: absolute;
  left: calc(50% - 47px);
  top: calc(50% - 47px);
  overflow: hidden;
}

.about .play-btn::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-40%) translateY(-50%);
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 16px solid #fff;
  z-index: 100;
  transition: all 400ms cubic-bezier(0.55, 0.055, 0.675, 0.19);
}

.about .play-btn::before {
  content: "";
  position: absolute;
  width: 120px;
  height: 120px;
  animation-delay: 0s;
  animation: pulsate-btn 2s;
  animation-direction: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: steps;
  opacity: 1;
  border-radius: 50%;
  border: 5px solid rgba(143, 192, 78, 0.7);
  top: -15%;
  left: -15%;
  background: rgba(198, 16, 0, 0);
}

.about .play-btn:hover::after {
  border-left: 16px solid var(--primaryColor);
  transform: scale(20);
}

.about .play-btn:hover::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-40%) translateY(-50%);
  width: 0;
  height: 0;
  border: none;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 16px solid #fff;
  z-index: 200;
  animation: none;
  border-radius: 0;
}

@keyframes pulsate-btn {
  0% {
    transform: scale(0.6, 0.6);
    opacity: 1;
  }

  100% {
    transform: scale(1, 1);
    opacity: 0;
  }
}

.about-border-shadow-left{
  border-left: 10px solid red;
  box-shadow: 0 0 20px rgb(151 163 174 / 25%);
}
.about-border-shadow-right{
  border-right: 10px solid red;
  box-shadow: 0 0 20px rgb(151 163 174 / 25%);
}
.about-border-shadow-left h1 {
  font-size: 2.2em;
}
.about-border-shadow-right h1{
  font-size: 2.2em;
}


@media (max-width: 991.98px){
  .about-border-shadow-left{
    border-left: none !important;
  }
  .about-border-shadow-right{
    border-right: none !important;
  }
  .about-border-shadow-left h1 {
    font-size: 1.9em!important;
  }
  .about-border-shadow-right h1{
    font-size: 1.9em!important;
  }
  .video-box-first{
    min-height: 300px;
  }
  .video-box-first{
    min-height: 300px;
  }
  .about .icon-box .description{
    font-size: 18px;
  }
}

/*--------------------------------------------------------------
# Why Us
--------------------------------------------------------------*/
.why-us .box {
  padding: 30px 25px;
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.1);
  transition: all ease-in-out 0.3s;
  height: 100%;
}

.why-us .box span {
  display: block;
  font-size: 28px;
  font-weight: 700;
  color: var(--primaryColor);
}

.why-us .box h4 {
  font-size: 24px;
  font-weight: 600;
  padding: 0;
  margin: 20px 0;
  color: #353535;
}

.why-us .box p {
  /* color: #919191; */
  font-size: 17px;
  margin: 0;
  padding: 0;
}

.why-us .box:hover {
  background: var(--primaryColor);
  padding: 20px 20px 60px 20px;
  box-shadow: 10px 16px 30px rgba(0, 0, 0, 0.18);
}

.why-us .box:hover span,
.why-us .box:hover h4,
.why-us .box:hover p {
  color: #fff;
}

/*--------------------------------------------------------------
# Counts
--------------------------------------------------------------*/
.counts {
  background: #fff;
  padding: 0 0 60px 0;
}

.counts .counters span {
  font-size: 48px;
  display: block;
  color: var(--primaryColor);
}

.counts .counters p {
  padding: 0;
  margin: 0 0 20px 0;
  font-family: "Archivo", sans-serif;
  font-size: 18px;
}

/*--------------------------------------------------------------
# Services
--------------------------------------------------------------*/
.services .icon-box {
  text-align: center;
  border: 1px solid #e5f0d5;
  padding: 80px 20px;
  transition: all ease-in-out 0.3s;
  background: #fff;
}

.services .icon-box .icon {
  margin: 0 auto;
  width: 64px;
  height: 64px;
  background: #e49d913b;
  border-radius: 50px;
  border: 1px solid #e49d913b;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  transition: ease-in-out 0.3s;
}

.services .icon-box .icon i {
  color: #bfdb99;
  font-size: 28px;
  transition: ease-in-out 0.3s;
}

.services .icon-box h4 {
  font-weight: 700;
  margin-bottom: 16px;
  font-size: 24px;
}

.services .icon-box h4 a {
  color: #353535;
  transition: ease-in-out 0.3s;
}

.services .icon-box p {
  line-height: 24px;
  font-size: 18px;
  margin-bottom: 0;
}

.services .icon-box:hover {
  border-color: #fff;
  box-shadow: 0px 0 25px 0 rgba(0, 0, 0, 0.1);
}

.services .icon-box:hover h4 a,
.services .icon-box:hover .icon i {
  color: var(--primaryColor);
}

.services .icon-box:hover .icon {
  border-color: var(--primaryColor);
}

/*--------------------------------------------------------------
# Portfolio
--------------------------------------------------------------*/
.portfolio {
  padding-bottom: 40px;
}

.portfolio #portfolio-flters {
  padding: 0;
  margin: 0 auto 25px auto;
  list-style: none;
  text-align: center;
  border-radius: 50px;
}

.portfolio #portfolio-flters li {
  cursor: pointer;
  display: inline-block;
  padding: 8px 16px 10px 16px;
  font-size: 18px;
  font-weight: 500;
  line-height: 1;
  color: #444444;
  margin: 0 3px 10px 3px;
  transition: all ease-in-out 0.3s;
  background: #efefef;
  border-radius: 50px;
}

.portfolio #portfolio-flters li:hover,
.portfolio #portfolio-flters li.filter-active {
  color: #fff;
  background: var(--primaryColor);
}

.portfolio #portfolio-flters li:last-child {
  margin-right: 0;
}

.portfolio .portfolio-item {
  margin-bottom: 30px;
  overflow: hidden;
}

.portfolio .portfolio-item img {
  position: relative;
  top: 0;
  transition: all 0.6s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.portfolio .portfolio-item .portfolio-info {
  opacity: 0;
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: -50px;
  z-index: 3;
  transition: all ease-in-out 0.3s;
  background: var(--primaryColor);
  padding: 16px 20px;
}

.portfolio .portfolio-item .portfolio-info h4 {
  font-size: 18px;
  color: #fff;
  font-weight: 600;
}

.portfolio .portfolio-item .portfolio-info p {
  color: #fff;
  font-size: 18px;
  margin-bottom: 0;
}

.portfolio .portfolio-item .portfolio-info .preview-link,
.portfolio .portfolio-item .portfolio-info .details-link {
  position: absolute;
  right: 50px;
  font-size: 24px;
  top: calc(50% - 18px);
  color: white;
  transition: ease-in-out 0.3s;
}

.portfolio .portfolio-item .portfolio-info .preview-link:hover,
.portfolio .portfolio-item .portfolio-info .details-link:hover {
  color: #e49d913b;
}

.portfolio .portfolio-item .portfolio-info .details-link {
  right: 16px;
}

.portfolio .portfolio-item:hover img {
  top: -30px;
}

.portfolio .portfolio-item:hover .portfolio-info {
  opacity: 1;
  bottom: 0;
}

/*--------------------------------------------------------------
# Team
--------------------------------------------------------------*/
.team {
  background: #fff;
  padding: 60px 0;
}

.team .member {
  margin-bottom: 20px;
  overflow: hidden;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.1);
}

.team .member .member-img {
  position: relative;
  overflow: hidden;
}

.team .member .social {
  position: absolute;
  left: 0;
  bottom: 30px;
  right: 0;
  opacity: 0;
  transition: ease-in-out 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.team .member .social a {
  transition: color 0.3s;
  color: #353535;
  margin: 0 3px;
  border-radius: 50px;
  width: 36px;
  height: 36px;
  background: var(--primaryColor);
  display: inline-block;
  transition: ease-in-out 0.3s;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.team .member .social a:hover {
  background: var(--primaryColor);
}

.team .member .social i {
  font-size: 18px;
  line-height: 0;
}

.team .member .member-info {
  padding: 25px 16px;
}

.team .member .member-info h4 {
  font-weight: 700;
  margin-bottom: 5px;
  font-size: 18px;
  color: #353535;
}

.team .member .member-info span {
  display: block;
  font-size: 13px;
  font-weight: 400;
  color: #aaaaaa;
}

.team .member .member-info p {
  font-style: italic;
  font-size: 18px;
  line-height: 26px;
  color: #777777;
}

.team .member:hover .social {
  opacity: 1;
  bottom: 16px;
}

/*--------------------------------------------------------------
# Contact
--------------------------------------------------------------*/
.contact .info {
  width: 100%;
  background: #fff;
}

.contact .info i {
  font-size: 20px;
  color: var(--primaryColor);
  float: left;
  width: 44px;
  height: 44px;
  background: #e49d913b;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  transition: all 0.3s ease-in-out;
}

.contact .info h4 {
  padding: 0 0 0 60px;
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 5px;
  color: #353535;
}

.contact .info p {
  padding: 0 0 0 60px;
  margin-bottom: 0;
  font-size: 18px;
  color: #686868;
}

.contact .info .email,
.contact .info .phone {
  margin-top: 40px;
}

.contact .info .email:hover i,
.contact .info .address:hover i,
.contact .info .phone:hover i {
  background: var(--primaryColor);
  color: #fff;
}

.contact .php-email-form {
  width: 100%;
  background: #fff;
}

.contact .php-email-form .form-group {
  padding-bottom: 8px;
}

.contact .php-email-form .error-message {
  display: none;
  color: #fff;
  background: #ed3c0d;
  text-align: left;
  padding: 16px;
  font-weight: 600;
}

.contact .php-email-form .error-message br+br {
  margin-top: 25px;
}

.contact .php-email-form .sent-message {
  display: none;
  color: #fff;
  background: #18d26e;
  text-align: center;
  padding: 16px;
  font-weight: 600;
}

.contact .php-email-form .loading {
  display: none;
  background: #fff;
  text-align: center;
  padding: 16px;
}

.contact .php-email-form .loading:before {
  content: "";
  display: inline-block;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  margin: 0 10px -6px 0;
  border: 3px solid #18d26e;
  border-top-color: #eee;
  animation: animate-loading 1s linear infinite;
}

.contact .php-email-form input,
.contact .php-email-form textarea {
  border-radius: 0;
  box-shadow: none;
  font-size: 18px;
}

.contact .php-email-form input {
  height: 44px;
}

.contact .php-email-form textarea {
  padding: 10px 12px;
}


@keyframes animate-loading {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}


/*--------------------------------------------------------------
# Footer
--------------------------------------------------------------*/

.footer-container {
  background-color: #f8f9fa;
  padding: 0 0;
}

.footer-content {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px; 
}

.footer-content > div {
  flex: 1 1;
  margin: 0 10px;
}

.about-hnh, .info-section, .support-section {
  margin-bottom: 20px;
}

.footer-content h3 {
  margin-top: 0;
}

.footer-content p {
  margin-bottom: 10px;
}

.footer-content a {
  color: var(--primaryColor);
}

@media screen and (max-width: 768px) {
  .footer-content {
    flex-direction: column;
  }
  .about-hnh, .info-section, .support-section {
    margin-top: 20px;
  }
  .footer{
    height:auto !important;
  }
}

.copyright {
  background-color: #00000040;
  color: #fff;
  padding: 10px;
  text-align: center;
  border-top: 1px solid var(--primaryColor);
  clear: both; 
}


.footer {
  background-color: #00000040 !important;
  color: #fff;
  padding: 20px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  height: 270px;
}


.info-section,
.support-section {
  /* flex: 1; */
  max-width: 400px;
}

.about-hnh {
  max-width: 400px;
}

.footer h2 {
  margin-bottom: 10px;
}

.footer p {
  margin: 0;
  font-size: 14px;
}

.accordion-button:not(.collapsed) {
  background-color: transparent !important;
  color: var(--primaryColor)!important;
}

.accordion-button:focus {
  border-color: none !important;
  box-shadow:none!important;
}

button.accordion-button {
  font-size: 20px !important;
  font-weight: 600 !important;
}



#job-listings {
  padding: 20px;
}

table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid var(--primaryColor);
  font-size: medium;
}

th, td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

/* JobListing.css */

.table-responsive {
  overflow-x: auto;
}

.job-table {
  width: 100%;
  border-collapse: collapse;
}

.job-table th,
.job-table td {
  padding: 8px;
  /* border: 1px solid #ddd; */
}

.job-table th {
  background-color: #e49d913b;
  text-align: left;
}

.job-table tbody tr:hover {
  background-color: #ddd;
}

@media screen and (max-width: 768px) {
  .job-table {
    font-size: 16px;
  }
}


.even-row {
  background-color: #ffffff;
}

.odd-row {
  background-color: #e49d913b;
}



/* Define the keyframes for the animation */
@keyframes fadeInUp {
  from {
      opacity: 0;
      transform: translateY(20px);
  }
  to {
      opacity: 1;
      transform: translateY(0);
  }
}

/* Apply animation to the table */
.animated-table tbody tr {
  animation: fadeInUp 0.5s ease-in-out;
}

/* Add delay to each row for staggered animation */
.animated-table tbody tr:nth-child(odd) {
  animation-delay: 0.1s;
}

.animated-table tbody tr:nth-child(even) {
  animation-delay: 0.2s;
}


.section-with-title-padding {
  padding-top: 80px;
}

.sendbtn:hover{
  color: white !important;
  background: rgb(240, 19, 19) !important;
}


/* skills section */
.skill-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.skill-group {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.skill-box {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(50% - 20px); 

  border: 2px solid #ccc;
  padding:  2px 0px 2px 0px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.skill-box:hover {
  /* background-color: #e49d913b; */
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); 
  transform: translateZ(10px); 
}

.skill-box h2 {
  margin-bottom: 10px;
}

.modal-overlay {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background-color: #fff!important;
  color: #000;
  padding: 20px;
  border-radius: 10px;
  max-width: 80%;
  max-height: 80%;
  overflow: auto;
  border-radius: 16px!important;
}

.modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

body.modal-open {
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: hidden;
}


.modal-content h2 {
  margin-bottom: 10px;
}

.modal-content p {
  margin-bottom: 20px;
  font-size: 1.2rem;
}

.modal-content ul {
  list-style-type: disc;
  margin-left: 20px;
  font-size: 1.2rem;
}

.modal-content ul li {
  margin-bottom: 5px;
}

.modal-content button {
  padding: 10px 20px;
  background-color: var(--primaryColor);
  color: white;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.modal-content button:hover {
  background-color: #a01707;
}

.additional-info {
  display: flex;
  justify-content: space-between;
}

@media screen and (max-width: 768px) {
  .skill-box {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(100% - 10px); 
    margin: 0px;
    padding: 2px;
  }
  
  .modal-content {
    width: 90%; 
  }
}

@media screen and (max-width: 480px) {
  .skill-box {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(100% - 10px); 
    margin: -5px 2px;
    padding: 2px 0px 2px;
  }
}

.tabs-container {
  display: flex;
  justify-content: space-between;
  max-width: 1333px; 
  margin: 0 auto; 
  display: flex;
}

.tabs-sidebar {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(25% - 20px); 
  padding: 20px;
}


.tabs-content {
  flex: 1 1;
  padding: 20px;
  display: flex;
  flex-direction: row; 
  flex-wrap: wrap; 
}


@media (max-width: 767.98px) {
  .tabs-content {
    flex-direction: column;
  }
}


.tabs-content .content-box > div {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(50% - 20px); 
}

@media (min-width: 768px) {
  .tabs-content .content-box > div {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(33.33% - 20px); 
  }
  
}
.content-box h2 {
  color: var(--primaryColor);
  font-weight: 600;
}

.tabs-sidebar .cursor-pointer {
  transition: background-color 0.3s ease;
  padding: 8px 16px;
  font-size: 1.3rem;
}

.tabs-sidebar .cursor-pointer:hover {
  background-color: #f0f0f0;
  font-weight: 600;
}


@media (max-width: 768px) {
  .tabs-container {
    flex-direction: column;
  }

  .tabs-sidebar {
    flex: 1 1;
  }
  .tabs-sidebar .cursor-pointer {
    transition: background-color 0.3s ease;
    padding: 1px 10px;
    font-size: 1.1rem;
    margin: 0px;
  }
  
}

.cursor-pointer {
  cursor: pointer;
}


/* .tabs-sidebar .cursor-pointer {
  transition: background-color 0.3s ease;
  padding: 8px 16px;
}

.tabs-sidebar .cursor-pointer:hover {
  background-color: #f0f0f0;
} */

.tabs-sidebar .cursor-pointer.active {
  background-color: #e49d913b;
  color: black;
  font-weight: 600;
}

.tab-sideBorder {
  border-left: 3px solid black;
}

.content-flex-dynamic {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}


@media (max-width: 767.98px) {
  .content-flex-dynamic {
    flex-direction: column;
  }

}

.hover-effect:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); 
  transform: translateZ(10px); 
}


@media screen and (max-width: 768px) {
  .responsive-container {
    flex-direction: column;
    width: 100%!important; 
    margin-right: 0;
  }
  .navbar a {
    padding: 10px !important;
  }
}


/* ProjecSteps */

.box-steps {
  border: 1px solid #000;
  padding: 10px;
  margin-bottom: 10px;
}

/* .connector {
  border-left: 2px solid #000;
  height: 100px;
  margin-left: 20px;
  margin-right: 20px;
} */


/* .box-card {
  position: relative;
  overflow: hidden;
  width: 100%;
  margin-bottom: 0; 
  opacity: 0.9;
}
.img-fluid-card {
  max-width: 100%;
  height: auto;
  display: block;
  transition: transform 0.5s ease, opacity 0.5s ease;
} */

.img-fluid-card {
  width: calc(2 * var(--height)); 
  /* width: 200px !important; */
  height: 100%; 
  max-width: 100%; 
  max-height: 100%; 
  object-fit: cover; 
  display: block;
  transition: transform 0.5s ease, opacity 0.5s ease;
  filter: brightness(75%);
}
.heading {
  position: absolute;
  top: 20px;
  left: 20px;
  color: white;
  z-index: 1;
  /* margin-bottom: 10px; */
}

.box-card {
  --height: 200px; 
  position: relative;
  overflow: hidden;
  width: calc(2 * var(--height)); 
  /* width: 30rem; */
  /* height: var(--height);  */
  height: 500px;
  margin-bottom: 0; 
  /* border-bottom-left-radius: 5rem;
  border-top-right-radius: 5rem; */
  /* border-radius: 25px; */
}

.box-card-content {
  position: relative;
  width: 100%;
  height: 100%;
  /* display: flex;
  justify-content: center;
  align-items: center; */
  transition: all 0.5s ease-in-out;
}

.box-card-content h2{
  font-size: 30px;
  transition: all 0.5s ease-in-out;
}
.box-card-content h3 {
  font-size: 30px;
  transition: all 0.5s ease-in-out;
}
.box-card-content:hover{
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.box-card-content:hover h2, .box-card-content:hover h3 {
  font-size: 30px;
  /* top: 10px;
  left: 10px; */
  padding: 10px;
}

.overlay-card {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background: linear-gradient(275deg, red, black); */
  opacity: 0.2;
  transition: opacity 0.5s ease;
}

.card-color-violet {
  background: #6F0673;
  background: linear-gradient(315deg, #6F0673, #010101);
}
.card-color-red {
  background: linear-gradient(120deg, rgb(21 20 22) 23%, rgb(55 6 6) 40%, rgba(249,0,0,1) 120%);
}
.card-color-black {
  background: linear-gradient(120deg, rgba(21,20,22,1) 0%, rgba(0,0,0,1) 56%, rgba(249,0,0,1) 100%);
}
@media (hover: hover) {
  /* No styles needed for devices with hover capability */
}

@media (hover: none) and (pointer: coarse) {
  .box-card-content .hidden-paragraph {
    /* position: relative; */
    z-index: 1;
    color: white;
    /* text-align: center; */
    margin: 0;
    padding: 0px;
    font-size: 20px;
    /* background-color: rgba(0, 0, 0, 0.5); */
    width: calc(100% - 40px);
    transform: translate(-50%, -50%);
    top: 55%;
    left: 50%;
    opacity: 1;
    transition: opacity 0.5s ease;
  }
  .box-card-content h2 {
    padding: 0px;
    font-size: 25px!important;
  }
  .box-card-content h3 {
    padding-left: 0px;
    font-size: 30px!important;
  }
  /* .box-card-content{
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  } */
  .overlay-card{
    opacity: 0.7;
  }
}


.box-card:hover .img-fluid-card {
  transform: translateX(-100%);
  opacity: 0;
}

.box-card:hover .overlay-card {
  opacity: 0.9;
}

.hidden-paragraph {
  position: absolute;
  top: 50%;
  right: -100%;
  width: 87%;
  transform: translateY(-50%);
  color: white;
  transition: right 0.5s ease;
}

.box-card:hover .hidden-paragraph {
  margin: 20px;
  right: 0px;
}




/* Statistics */
.red {
  color: red;
}

.vertical-line {
  width: 2px;
  background-color: red;
  height: 80px; 
}

.icon-and-line {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

@media (max-width: 576px) { 
  .icon-and-line {
    flex-direction: row; 
    justify-content: center; 
    margin-bottom: 20px; 
  }
  
  .icon-and-line .vertical-line {
    display: none; /* Hide vertical lines on mobile */
  }
}

/* Our Project */
.yellow-background {
  background-color: rgb(195 195 195);
}

.violet-background {
  background-color: #ff000029;
}

.orange-background {
  background-color: rgb(249 118 1 / 29%);
}
.blue-background{
  background-color: rgb(0 6 255 / 18%)
}


/* .section-with-background:before {
  content: "";
  background-image: url(https://www.solulab.com/wp-content/themes/Avada-Child-Theme/images/dot-bg.png);
  position: absolute;
  left: 0;
  top: 100px;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  width: 100%;
} */

.section-with-background {
  background-image: url(https://www.solulab.com/wp-content/themes/Avada-Child-Theme/images/dot-bg.png);
  background-size: cover;
}

.left-section-border {
  border-top-right-radius: 65px;
  border-bottom-right-radius: 65px;
  border: 1px solid red;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}

.right-section-border {
  border-top-left-radius: 65px;
  border-bottom-left-radius: 65px;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  border: 1px solid red;
}

.icon-border {
  border: 1px solid red;
    border-radius: 50%;
    padding: 1.2rem;
    color: red;
    border-bottom-width: medium;
}

.arrow {
  width: 20px;
  height: 20px;
  position: absolute;
  bottom: 10px;
  z-index: 1;
  background-color: rgb(221, 128, 128); 
}

.arrow-left {
  left: 10px;
}

.arrow-right {
  right: 10px;
}

.arrow::before {
  content: '';
  display: block;
  width: 20px;
  height: 20px;
  background-color: rgb(226, 128, 128); 
  position: absolute;
  bottom: 0;
  right: 0;
  transform: rotate(45deg); 
}


/* .arrow-container {
  position: absolute;
  bottom: 0;
  right: 0;
  transform: translate(50%, 50%) rotate(45deg);
} */

.dot-icon {
  color: rgb(254, 122, 122); 
  font-size: 24px; 
  margin-right: 5px; 
}

.arrow-container {
  position: absolute;
  bottom: 0;
  right: 0;
  transform: translate(-50%, 50%);
}

.arrow-container {
  width: 0px; 
  height: 0px; 
}

.arrow-icon {
  color: rgb(254, 122, 122); 
  font-size: 26px; 
  transform: scaleX(2); 

}

@media (max-width: 991.98px) {
  .arrow-container {
    display: none;
  }
}

.rounded-10 {
  border-radius: 10px;
}

@media (max-width: 775px) {
  .rounded-10 {
      border-radius: 20px;
  }
}

/* .left-arrow {
  left: 0;
  transform: rotate(135deg);
}

.right-arrow {
  right: 0;
  transform: rotate(45deg);
} */

.left-arrow {
  left: 0px;
  transform: rotate(135deg);
}

.right-arrow {
  right: 0px;
  transform: rotate(45deg);
}

@media only screen and (max-width: 1200px) {
  .left-arrow {
    left: 0px;
    transform: rotate(135deg);
  }
  
  .right-arrow {
    right: 0px;
    bottom: 4px;
    transform: rotate(45deg);
  }
}

@media only screen and (max-width: 900px) {
  .left-arrow {
    /* left: -30px; */
    transform: rotate(135deg);
  }
  
  .right-arrow {
    /* right: -30px; */
    transform: rotate(45deg);
  }
}

.custom-icon:hover .arrow-icon,
.custom-icon:hover .dot-icon {
  color: red;
}
.custom-icon:hover .icon-border{
  color: white;
  background-color: red;
}













.darksoul-gradient-card3 {
  background: linear-gradient(var(--gradient-angle), rgb(255, 16, 3), rgb(0, 0, 0), rgb(250, 81, 58), rgb(0, 0, 0));
  border-radius: 5px;
  animation: rotation 5s linear 0s infinite normal forwards;
  backdrop-filter: blur(50px);
}

.darksoul-content-card {
  background-color: white;
  border-radius: 5px;
  transition: all 0.2s;
  backdrop-filter: blur(5px);
  display: flex;
  flex-direction: row;
}

.darksoul-content-card h2 {
  /* font-family: 'Archivo', sans-serif; */
  color: black;
  /* font-size: 20px; */
  margin: auto;
  font-weight: 100;
}

.darksoul-content-card p {
  font-family: 'Archivo', sans-serif;
  color: black;
  font-size: 16px;
}

.skill-box {
  transition: box-shadow 0.3s ease-in-out; 
}

.skill-box:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); 
}

@keyframes rotation {
  0% {
    --gradient-angle: 0deg;
  }
  100% {
    --gradient-angle: 360deg;
  }
}

@property --gradient-angle {
  syntax: "<angle>";
  initial-value: 0deg;
  inherits: false;
}




.application-form-container {
  max-width: 500px;
  margin: 0 auto;
  padding: 20px;
  /* background-color: white !important; */
  border-radius: 10px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}

.application-form-container h2 {
  margin-bottom: 20px;
}

.application-form-container .form-control {
  margin-bottom: 15px;
}

.application-form-container .btn {
  width: 100%;
}





.card {
  transition: box-shadow 0.3s;
}

.card:hover {
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

.card-img-top {
  object-fit: cover;
  height: 200px;
}



/* case-study */
.heading-size{
  font-size: 40px !important;
}

.prev-icon, .next-icon {
  color: black;
  font-size: 18px;
  font-weight: 600;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.3); 
  text-decoration: none;
}

.prev-icon:hover, .next-icon:hover {
  color: red;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.3); 
}
.prev-icon .border:hover, .next-icon .border:hover {
  color: red;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3); 
}



/* 
Parallax styles
*/
.parallax {
  min-height: 35vh; 
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size:cover;
  
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative; 
}
.about-img {
  /* background-image: url("../img/about/BG10.jpg"); */
    background: 
    linear-gradient(90deg, rgb(3 10 9/50%), rgb(255 0 0 / 50%)),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center/cover fixed; 
}
.service-img {
  /* background-image: url("../img/about/BG12.jpg"); */
  background: 
  linear-gradient(125deg, rgb(3 10 9/50%), rgb(255 0 0 / 25%)),
  url(${___CSS_LOADER_URL_REPLACEMENT_5___}) center/cover fixed; 
}
.case-study-img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.techno-img {
  /* background-image: url("../img/about/BG14.jpg"); */
  background: 
  linear-gradient(125deg, rgb(3 10 9/50%), rgb(255 0 0 / 50%)),
  url(${___CSS_LOADER_URL_REPLACEMENT_7___}) center/cover fixed; 
}
.career-img {
  /* background-image: url("../img/career/career.png"); */
  background: 
  linear-gradient(90deg, rgb(3 10 9/70%), rgb(255 0 0 / 60%)),
  url(${___CSS_LOADER_URL_REPLACEMENT_8___}) center/cover fixed; 
}
.contact-img {
  /* background-image: url("../img/contact/contact.jpg"); */
  background: 
  linear-gradient(90deg, rgb(3 10 9/30%), rgb(255 0 0 / 40%)),
  url(${___CSS_LOADER_URL_REPLACEMENT_9___}) center/cover fixed; 
}

.logo-img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}


.parallax-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); 
}

.parallax h1 {
  color: white; 
  position: relative; 
  z-index: 1; 
  font-size: 4em;
  font-weight: 600;
  text-align: center;
}

/* Footer */

.footer-container {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: cover;
  background-position: center;
  min-height: 365px; 
  background-attachment: fixed;

}

.footer-content {
  margin-left: auto;
  margin-right: auto;
  max-width: 1200px; 
}

.about-hnh {
  /* text-align: center; */
}

.social {
  margin-top: 20px;
}

.info-section,
.support-section {
  color: white;
}

.info-section p,
.support-section p {
  margin-bottom: 10px;
}

.footer-container .copyright {
  /* position: absolute; */
  bottom: 0;
  left: 0;
  width: 100%;
  /* padding: 20px; */
  text-align: center;
}

.parallax-section {
  position: relative;
  overflow: hidden;
}

.Toastify__toast-container--top-right{
  top: 15%!important;
}



/* error */
.error-container {
  text-align: center;
  margin-top: 100px;
}

.error-image {
  max-width: 300px;
  margin-bottom: 30px;
}

.error-heading {
  font-size: 36px;
  color: #343a40;
  margin-bottom: 20px;
}

.error-message {
  font-size: 18px;
  color: #6c757d;
  margin-bottom: 20px;
}
/* error */


.circle {
  width: 150px;
  height: 150px;
  /* border-radius: 50%; */
  overflow: hidden;
  margin: 0 auto;
}

.circle .rounded-circle {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}
.edit-icon {
  position: absolute;
  bottom: 5px;
  right: 5px;
  font-size: 1.2rem;
  color: #fff;
  cursor: pointer;
  background-color: black;
  padding: 10px;
  border-radius: 50%;
}






/* Employee Handbook */
.auth-card{
  padding: 20px;
  text-align: center;
  max-width: 400px;
  margin: 10% auto;
  box-shadow: 2px 10px 18px 2px rgb(230, 173, 173)
}

.modal-background {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); 
  z-index: 1040; 
}


input.form-control, select, textarea{
  box-shadow: none!important;
}


.no-hover-card:hover {
  box-shadow: none;
}

@media only screen and (max-width: 991px) {
  span.hidetext{
    display: none!important;
  }
  .showrow{
    display: flex;
  }
  .center-icon{
    justify-content: center;
  }
  .icon-size{
    font-size: 20px;
    padding: 0px;
    margin: 0px;
  }
  .nav-link{
    padding: 10px;
  }
}


.sticky-sidebar{
  position: sticky;
  top: 50px;
  background: white;
  z-index: 999;
}

/* Custom CSS for the modal */
.custom-modal {
  position: fixed;
  top: 0;
  right: 0;
  width: 50%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  z-index: 1050;
  justify-content: center;
}

.modal-content {
  width: 100%;
  max-width: 98%;
  max-height: 90%;
  background-color: white;
  border-radius: 10px;
  overflow: auto;
  /* animation: slideIn 0.5s forwards; */
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

/* attendance */
.center-line {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  z-index:-1;
}

/* Announcement skeleton */
.skeleton-card {
  background-color: #f0f0f0;
  height: 80px; 
  border-radius: 8px;
  position: relative;
  overflow: hidden;
}

.skeleton-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent);
  animation: shimmer 1s infinite;
}

@keyframes shimmer {
  100% {
    left: 100%;
  }
}
/* Announcement skeleton */

.form-control-announce {
  width: 100%;
  padding: 2px;
  border: none;
  border-radius: 0;
  border-bottom: 2px solid #0058b1;
  padding: 0.5rem 0;
}

.form-control-announce {
  /* border-color: #ced4da; */
  border-color: #ced4da61;
  transition: border-color 0.5s ease-in-out;
  font-size: 15.6px;
}

.form-control-announce:focus,
.form-control-announce:hover {
  border-bottom: 2px solid rgb(102, 102, 247);
  outline: none;
}

@keyframes borderAnimation {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 100% 0;
  }
}

.form-control-announce:focus,
.form-control-announce:hover {
  animation: borderAnimation 1s forwards;
}

#border-in-table {
  border: 1px solid;
  width: 20% !important;
  /* border-bottom: none !important; */
  margin: 0 auto !important;
  z-index: 12 !important;
}

@media (max-width: 767px) {
  #border-in-table {
    width: 100% !important;
  }
}



.font-title {
  font-size: 19px;
}
.font-sub-title {
  font-size: 16px;
}
.font-content {
  font-size: 13px;
}



/* Image */
.circle-image {
  width: 10px;
  height: 10px;
  /* overflow: hidden; */
  border-radius: 10%;
}

.bullet {
  color: #dc3545;
  margin-right: 0.5rem;
}

.submenu {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out;
}

.submenu.open {
  max-height: 100px;
}


/* SideNavbar.css */

/* .icon-size {
  font-size: 1.5em;
} */

.sidebar:hover .hidetext {
  display: inline;
}

.submenu {
  display: none;
}

.submenu.open {
  display: block;
}

.nav-link {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.badge {
  font-size: 0.75em;
  margin-left: 5px;
}

.position-sticky {
  position: sticky;
  top: 0;
}

@media (max-width: 992px) {
  .sidebar {
    display: none;
  }
  
  .sidebar-offcanvas .nav-link {
    display: flex;
    align-items: center;
  }

  .hidetext {
    display: inline;
  }
}

@media (max-width: 768px) {
  .sidebar {
    width: 60px;
  }

  .sidebar:hover {
    width: 150px;
  }
}

.offcanvas-custom {
  width: 50%;
}

.offcanvas-backdrop-custom {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
  display: none;
}

.offcanvas-backdrop-custom.show {
  display: block;
}

.form16-table tbody > tr > td {
  font-size: 13px;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.navbar-collapse {
  display: flex;
  justify-content: flex-end;
}

.navbar-nav {
  display: flex;
}

.navbar-toggler {
  display: none; 
}

@media (max-width: 991px) {
  .navbar-collapse {
    flex-direction: column;
    overflow: hidden;
    transition: max-height 0.35s ease, opacity 0.35s ease;
    max-height: 0;
    opacity: 0;
  }

  .navbar-collapse.show {
    max-height: 500px;
    opacity: 1;
  }

  .navbar-toggler {
    display: block;
  }

  .navbar-nav {
    display: flex;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":";AAIA;;+DAE+D;;AAE/D;EACE,uBAAuB;AACzB;AACA;EACE,0CAA0C;EAC1C,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,qBAAqB;;AAEvB;;AAEA;;;;;;;;;;;GAWG;AACH,4BAA4B;AAC5B,4BAA4B;AAC5B;EACE,gCAAgC;AAClC;;;AAGA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE;IACE,sDAAsD;EACxD;;EAEA;IACE,sDAAsD;EACxD;;EAEA;IACE,sDAAsD;EACxD;EACA;IACE,sDAAsD;EACxD;AACF;;AAEA;EACE;IACE,sDAAsD;EACxD;EACA;IACE,sDAAsD;EACxD;EACA;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;+DAE+D;AAC/D;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;;+DAE+D;AAC/D;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;;EAEE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;;;AAGA;;+DAE+D;AAC/D;EACE,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;;EAEE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;;;AAIA;EACE,cAAc;EACd,eAAe;AACjB;AACA;;+DAE+D;AAC/D;;CAEC;AACD;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB;AACF;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;EAIE,0BAA0B;AAC5B;;;AAGA;;CAEC;AACD;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;EACT,iCAAiC;EACjC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;8DAEqD;EACrD,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,SAAS;EACT,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;EACrC,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,+CAA+C;EAC/C,oCAAoC;EACpC,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,kBAAkB;EACpB;;AAEF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;;+DAE+D;AAC/D;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,qBAAqB;EACrB,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;;+DAE+D;AAC/D;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,2EAAgE;EAChE,sBAAsB;EACtB,iBAAiB;EACjB,2CAA2C;AAC7C;AACA;EACE,2EAAiE;EACjE,sBAAsB;EACtB,iBAAiB;EACjB,2CAA2C;AAC7C;AACA;EACE,2EAAsE;EACtE,sBAAsB;EACtB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iFAAiF;EACjF,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,4CAA4C;EAC5C,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,qCAAqC;EACrC,4BAA4B;EAC5B,YAAY;EACZ,4DAA4D;AAC9D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,mCAAmC;EACnC,gCAAgC;EAChC,UAAU;EACV,kBAAkB;EAClB,yCAAyC;EACzC,SAAS;EACT,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,4CAA4C;EAC5C,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,kCAAkC;EAClC,qCAAqC;EACrC,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;IAC1B,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,UAAU;EACZ;AACF;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;AACA;EACE,4BAA4B;EAC5B,2CAA2C;AAC7C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;;AAGA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;;+DAE+D;AAC/D;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;+DAE+D;AAC/D;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;;+DAE+D;AAC/D;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;+DAE+D;AAC/D;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,yDAAyD;AAC3D;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,UAAU;EACV,gCAAgC;EAChC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;;+DAE+D;AAC/D;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,qBAAqB;EACrB,4BAA4B;EAC5B,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;;+DAE+D;AAC/D;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;EAGE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;;+DAE+D;;AAE/D;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;AACb;;;AAGA;EACE,sCAAsC;EACtC,WAAW;EACX,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,aAAa;AACf;;;AAGA;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;;;AAIA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,mBAAmB;;AAEnB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;;;AAIA,2CAA2C;AAC3C;EACE;MACI,UAAU;MACV,2BAA2B;EAC/B;EACA;MACI,UAAU;MACV,wBAAwB;EAC5B;AACF;;AAEA,iCAAiC;AACjC;EACE,oCAAoC;AACtC;;AAEA,kDAAkD;AAClD;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,uCAAuC;AACzC;;;AAGA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;;EAE1B,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE;IACE,YAA2B;IAA3B,cAA2B;IAA3B,6BAA2B;IAC3B,WAAW;IACX,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,YAA2B;IAA3B,cAA2B;IAA3B,6BAA2B;IAC3B,gBAAgB;IAChB,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,aAAa;AACf;;;AAGA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;;AAGA;EACE;IACE,sBAAsB;EACxB;AACF;;;AAGA;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;AAC5B;;AAEA;EACE;IACE,YAA6B;IAA7B,cAA6B;IAA7B,+BAA6B;EAC/B;;AAEF;AACA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;;AAGA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,SAAO;EACT;EACA;IACE,sCAAsC;IACtC,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;EACb;;AAEF;;AAEA;EACE,eAAe;AACjB;;;AAGA;;;;;;;GAOG;;AAEH;EACE,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;;AAGA;EACE;IACE,sBAAsB;EACxB;;AAEF;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;;AAGA;EACE;IACE,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;AACF;;;AAGA,gBAAgB;;AAEhB;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;GAKG;;;AAGH;;;;;;;;;;;;GAYG;;AAEH;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kDAAkD;EAClD,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB;kCACgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ;;wBAEsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf;eACa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,qDAAqD;AACvD;AACA;EACE,6FAA6F;AAC/F;AACA;EACE,iGAAiG;AACnG;AACA;EACE,uDAAuD;AACzD;;AAEA;EACE;IACE,wBAAwB;IACxB,UAAU;IACV,YAAY;IACZ,wBAAwB;IACxB,SAAS;IACT,YAAY;IACZ,eAAe;IACf,0CAA0C;IAC1C,wBAAwB;IACxB,gCAAgC;IAChC,QAAQ;IACR,SAAS;IACT,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,YAAY;IACZ,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;EACA;;;;KAIG;EACH;IACE,YAAY;EACd;AACF;;;AAGA;EACE,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;;;;AAKA,eAAe;AACf;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa,EAAE,kCAAkC;EACnD;AACF;;AAEA,gBAAgB;AAChB;EACE,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;AACA;EACE;AACF;;;AAGA;;;;;;;;;;GAUG;;AAEH;EACE,oGAAoG;EACpG,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,qBAAqB;EACrB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,6BAA6B;EAC7B,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;IACnB,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,2BAA2B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,wBAAwB;AAC1B;;;AAGA;;;;;GAKG;;AAEH;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,oBAAoB;;AAEtB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;MACI,mBAAmB;EACvB;AACF;;AAEA;;;;;;;;GAQG;;AAEH;EACE,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE;IACE,SAAS;IACT,yBAAyB;EAC3B;;EAEA;IACE,UAAU;IACV,WAAW;IACX,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;AACF;;AAEA;;EAEE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;;;;;;;;;;;;;;AAcA;EACE,iHAAiH;EACjH,kBAAkB;EAClB,yDAAyD;EACzD,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;;;;AAKA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;;;;;AAMA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;;;AAIA,eAAe;AACf;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,wCAAwC;AAC1C;AACA;EACE,UAAU;EACV,uCAAuC;AACzC;;;;AAIA;;CAEC;AACD;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;;EAErB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,oDAAoD;IAClD;;8DAE+C;AACnD;AACA;EACE,oDAAoD;EACpD;;4DAEgD;AAClD;AACA;EACE,yDAA6C;AAC/C;AACA;EACE,oDAAoD;EACpD;;4DAEiD;AACnD;AACA;EACE,uDAAuD;EACvD;;4DAEkD;AACpD;AACA;EACE,yDAAyD;EACzD;;4DAEoD;AACtD;;AAEA;EACE,0DAA4C;AAC9C;;;AAGA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,WAAW;;AAEX;EACE,kBAAkB;EAClB,yDAA6C;EAC7C,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;EACjB,4BAA4B;;AAE9B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,SAAS;EACT,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;;;AAIA,UAAU;AACV;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA,UAAU;;;AAGV;EACE,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;;;;;;AAOA,sBAAsB;AACtB;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;AACf;;;AAGA;EACE,0BAA0B;AAC5B;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;EACb;EACA;IACE,aAAa;EACf;AACF;;;AAGA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,WAAW;EACX,UAAU;AACZ;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;EACZ;AACF;AACA,0BAA0B;;AAE1B;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;;EAEE,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,oCAAoC;EACpC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;;;AAIA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;;;AAIA,UAAU;AACV;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;;AAGA,mBAAmB;;AAEnB;;GAEG;;AAEH;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EAEE,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,sBAAsB;IACtB,gBAAgB;IAChB,qDAAqD;IACrD,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;AACF","sourcesContent":["\n@import '~boxicons/css/boxicons.min.css';\n@import '~bootstrap-icons/font/bootstrap-icons.css';\n\n/*--------------------------------------------------------------\n# General\n--------------------------------------------------------------*/\n\n:root {\n  --primaryColor: #DA251C;\n}\nbody {\n  /* font-family: \"Open Sans\", sans-serif; */\n  font-family: 'Archivo', sans-serif;\n  /* color: #444444; */\n}\n\na {\n  text-decoration: none;\n  color: var(--primaryColor);\n}\n\na:hover {\n  color: #0b0909;\n  text-decoration: none;\n\n}\n\n/* h1,\nh2,\nh3,\nh4,\nh5,\nh6{\n  font-family: \"Archivo\", sans-serif;\n}\np {\n  font-family: \"Archivo\", sans-serif;\n  font-size: 20px;\n} */\n/* Base font size variable */\n/* Base font size variable */\n:root {\n  --base-font-size: 20px!important; \n}\n\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: \"Archivo\", sans-serif;\n}\n\np {\n  font-family: \"Archivo\", sans-serif;\n  font-size: 1rem; \n}\n\n@media (max-width: 768px) {\n  h1 {\n    font-size: calc(var(--base-font-size) * 2.7)!important; \n  }\n\n  h2 {\n    font-size: calc(var(--base-font-size) * 2.2)!important; \n  }\n\n  h3 {\n    font-size: calc(var(--base-font-size) * 1.7)!important; \n  }\n  h4 {\n    font-size: calc(var(--base-font-size) * 1.2)!important; \n  }\n}\n\n@media (max-width: 480px) {\n  h1 {\n    font-size: calc(var(--base-font-size) * 2.5)!important; \n  }\n  h3 {\n    font-size: calc(var(--base-font-size) * 1.5)!important; \n  }\n  h4 {\n    font-size: calc(var(--base-font-size) * 1)!important; \n  }  \n}\n\n.logo-container {\n  width: 100%; \n  height: auto; \n  background-color: transparent;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.img-fluid {\n  max-width: 100%;\n  max-height: 100%;\n  background-color: transparent;\n}\n\n/*--------------------------------------------------------------\n# Disable AOS delay on mobile\n--------------------------------------------------------------*/\n@media screen and (max-width: 768px) {\n  [data-aos-delay] {\n    transition-delay: 0 !important;\n  }\n}\n\n/*--------------------------------------------------------------\n# Top Bar\n--------------------------------------------------------------*/\n#topbar {\n  background: #1c1c1c;\n  padding: 10px 0;\n  font-size: 14px;\n  color: #9b9b9b;\n}\n\n#topbar .contact-info i {\n  font-style: normal;\n  color: var(--primaryColor);\n}\n\n#topbar .contact-info i a,\n#topbar .contact-info i span {\n  padding-left: 5px;\n  color: #fff;\n}\n\n#topbar .contact-info i a {\n  line-height: 0;\n  transition: 0.3s;\n}\n\n#topbar .contact-info i a:hover {\n  color: var(--primaryColor);\n}\n\n#topbar .social-links a {\n  color: #9b9b9b;\n  line-height: 0;\n  transition: 0.3s;\n  margin-left: 10px;\n}\n\n#topbar .social-links a:hover {\n  color: white;\n}\n\n.social {\n  display: flex;\n  gap: 16px;\n  margin-top: 16px;\n  font-size: 20px;\n}\n.social i:hover {\n  font-size: 22px;\n  transition: 100ms ease;\n  color: whitesmoke;\n}\n\n\n/*--------------------------------------------------------------\n# Header\n--------------------------------------------------------------*/\n#header {\n  height: 70px;\n  transition: all 0.5s;\n  z-index: 997;\n  transition: all 0.5s;\n  background: #0f0f0f;\n  position: sticky;\n  top: 0px;\n  /* opacity: 0.8; */\n}\n\n#header .logo h1 {\n  /* font-size: 28px; */\n  margin: 0;\n  padding: 11px 0;\n  line-height: 1;\n  font-weight: 700;\n  letter-spacing: 1px;\n  font-family: \"Archivo\", sans-serif;\n}\n\n#header .logo h1 a,\n#header .logo h1 a:hover {\n  color: var(--primaryColor);\n  text-decoration: none;\n}\n\n#header .logo img {\n  padding: 0;\n  margin: 0;\n  max-height: 68px;\n}\n\n.scrolled-offset {\n  margin-top: 70px;\n}\n.navbar .navbar-brand {\n  font-size: 30px;\n}\n.navbar-brand {\n  font-size: 2.5rem!important;\n}\n.navbar .nav-item {\n  padding: 10px 20px;\n}\n.navbar .nav-links {\n  font-size: 16px;\n  margin-left: 10px;\n}\n.nav-links.active {\n  color: red!important;\n}\n.navbar-toggler {\n  border: none!important;\n}\n\n.navbar-small {\n  height: 50px;\n}\n\n.navbar-collapse {\n  transition: max-height 0.3s ease;\n  overflow: hidden;\n}\n\n.navbar-collapse.show {\n  max-height: 500px;\n}\n\n\n\n.fa-bars {\n  color: #007bff;\n  font-size: 30px;\n}\n/*--------------------------------------------------------------\n# Navigation Menu\n--------------------------------------------------------------*/\n/**\n* Desktop Navigation \n*/\n.navbar {\n  padding: 0;\n}\n\n.navbar ul {\n  margin: 0;\n  padding: 0;\n  display: flex;\n  list-style: none;\n  align-items: center;\n}\n\n.navbar li {\n  position: relative;\n}\n\n.navbar a,\n.navbar a:focus {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 0 10px 30px;\n  font-family: \"Archivo\", sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  color: #fff;\n  text-transform: uppercase;\n  white-space: nowrap;\n  transition: 0.3s;\n  text-decoration: none\n}\n\n.navbar a i,\n.navbar a:focus i {\n  font-size: 12px;\n  line-height: 0;\n  margin-left: 5px;\n}\n\n.navbar a:hover,\n.navbar .active,\n.navbar .active:focus,\n.navbar li:hover>a {\n  color: var(--primaryColor);\n}\n\n\n/**\n* Mobile Navigation \n*/\n.mobile-nav-toggle {\n  color: #fff;\n  font-size: 28px;\n  cursor: pointer;\n  display: none;\n  line-height: 0;\n  transition: 0.5s;\n}\n\n@media (max-width: 991px) {\n  .mobile-nav-toggle {\n    display: block;\n  }\n\n  .navbar ul {\n    display: none;\n  }\n}\n\n.navbar-mobile {\n  position: fixed;\n  overflow: hidden;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: rgba(28, 28, 28, 0.9);\n  transition: 0.3s;\n  z-index: 999;\n}\n\n.navbar-mobile .mobile-nav-toggle {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n}\n\n.navbar-mobile ul {\n  display: block;\n  position: absolute;\n  top: 55px;\n  right: 16px;\n  bottom: 16px;\n  left: 16px;\n  padding: 10px 0;\n  border-radius: 8px;\n  background-color: #fff;\n  overflow-y: auto;\n  transition: 0.3s;\n}\n\n.navbar-mobile a,\n.navbar-mobile a:focus {\n  padding: 10px 20px;\n  font-size: 16px;\n  color: #353535;\n}\n\n.navbar-mobile a:hover,\n.navbar-mobile .active,\n.navbar-mobile li:hover>a {\n  color: var(--primaryColor);\n}\n\n#hero {\n  position: relative;\n  width: 100%;\n  height: 80vh;\n  overflow: hidden;\n}\n\n#hero:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: \n    linear-gradient(90deg, rgb(3 10 9/50%), rgb(255 0 0 / 70%)),\n    url(\"../img/blockchainhigh.jpg\") center/cover fixed; \n  z-index: -1;\n  opacity: 0.8;\n  transition: opacity 0.5s ease;\n}\n\n#hero .hero-container {\n  position: absolute;\n  background: rgba(0, 0, 0, 0.6);\n  bottom: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  text-align: center;\n  padding: 0 16px;\n}\n\n\n#hero h1 {\n  margin: 0 0 10px 0;\n  /* font-size: 48px; */\n  font-weight: 700;\n  line-height: 56px;\n  color: #fff;\n}\n\n#hero h5 {\n  color: #eee;\n  margin-bottom: 20px;\n  /* font-size: 24px; */\n}\n\n.btn-get-started {\n  font-family: \"Archivo\", sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  letter-spacing: 1px;\n  display: inline-block;\n  padding: 8px 28px;\n  border-radius: 50px;\n  transition: 0.5s;\n  margin: 10px;\n  border: 2px solid var(--primaryColor);\n  color: #fff;\n  text-decoration: none;\n}\n\n.btn-get-started:hover {\n  background: var(--primaryColor);\n}\n\n.btn-button {\n  font-weight: 500!important;\n  font-size: 16px!important;\n  letter-spacing: 1px!important;\n  display: inline-block!important;\n  padding: 8px 28px!important;\n  border-radius: 50px!important;\n  transition: 0.5s!important;\n  margin: 10px!important;\n  border: 2px solid var(--primaryColor)!important;\n  color: var(--primaryColor)!important;\n  text-decoration: none!important;\n  background-color: white!important;\n}\n\n.btn-button:hover {\n  background: var(--primaryColor)!important;\n  color: white!important;\n}\n\n@media (min-width: 1024px) {\n  #hero {\n    background-attachment: scroll;\n  }\n  .box-heading {\n    text-align: center;\n  }\n\n}\n\n@media (max-width: 768px) {\n  #hero {\n    height: 100vh;\n  }\n\n  #hero h1 {\n    /* font-size: 28px; */\n    line-height: 36px;\n  }\n\n  #hero h2 {\n    /* font-size: 18px; */\n    line-height: 24px;\n    margin-bottom: 30px;\n  }\n  .box-heading {\n    text-align: center;\n  }\n  .navbar .nav-links {\n    font-size: 16px;\n    margin: 10px;\n  }\n}\n\n/*--------------------------------------------------------------\n# Sections General\n--------------------------------------------------------------*/\nsection {\n  padding: 40px 0;\n  overflow: hidden;\n}\n\n.section-title {\n  text-align: center;\n  padding-bottom: 30px;\n}\n\n.section-title h2 {\n  /* font-size: 28px; */\n  letter-spacing: 1px;\n  font-weight: 700;\n  padding: 8px 20px;\n  margin: 0;\n  background: #e49d913b;\n  color: var(--primaryColor);\n  display: inline-block;\n  text-transform: uppercase;\n  border-radius: 50px;\n}\n\n.section-title h3 {\n  margin: 16px 0 0 0;\n  font-size: 32px;\n  font-weight: 700;\n}\n\n.section-title h3 span {\n  color: var(--primaryColor);\n}\n\n.section-title p {\n  margin: 16px auto 0 auto;\n  /* font-weight: 600; */\n}\n\n@media (min-width: 1024px) {\n  .section-title p {\n    width: 100%;\n  }\n}\n\n/*--------------------------------------------------------------\n# About\n--------------------------------------------------------------*/\n.about .box-heading h4 {\n  font-size: 28px;\n  letter-spacing: 1px;\n  font-weight: 700;\n  padding: 8px 20px;\n  margin: 0 0 16px 0;\n  background: #e49d913b;\n  color: var(--primaryColor);\n  display: inline-block;\n  text-transform: uppercase;\n  border-radius: 50px;\n}\n\n.about .box-heading h3 {\n  font-size: 28px;\n  font-weight: 700;\n  color: #353535;\n  margin-bottom: 16px;\n}\n\n.about .icon-box {\n  margin-top: 40px;\n}\n\n.about .icon-box .icon {\n  float: left;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 50px;\n  height: 50px;\n  border: 2px solid #e49d913b;\n  border-radius: 50px;\n  transition: 0.5s;\n}\n\n.about .icon-box .icon i {\n  color: var(--primaryColor);\n  font-size: 32px;\n}\n\n.about .icon-box:hover .icon {\n  background: var(--primaryColor);\n  border-color: var(--primaryColor);\n}\n\n.about .icon-box:hover .icon i {\n  color: #fff;\n}\n\n.about .icon-box .title {\n  margin-left: 85px;\n  font-weight: 700;\n  margin-bottom: 10px;\n  font-size: 18px;\n}\n\n.about .icon-box .title a {\n  color: #343a40;\n  transition: 0.3s;\n}\n\n.about .icon-box .title a:hover {\n  color: var(--primaryColor);\n}\n\n.about .icon-box .description {\n  /* margin-left: 66px; */\n  line-height: 1.4em;\n  font-size: 1.3em;\n  color: black;\n}\n\n.video-box-first {\n  background: url(\"../img/about/BG12.jpg\") center center no-repeat;\n  background-size: cover;\n  min-height: 350px;\n  /* box-shadow: 0 0 20px rgb(0 0 0 / 70%); */\n}\n.video-box-second {\n  background: url(\"../img/about/trade.jpg\") center center no-repeat;\n  background-size: cover;\n  min-height: 350px;\n  /* box-shadow: 0 0 20px rgb(0 0 0 / 70%); */\n}\n.video-box-third {\n  background: url(\"../img/about/pexels-303.jpg\") center center no-repeat;\n  background-size: cover;\n  min-height: 350px;\n  /* box-shadow: 0 0 20px rgb(0 0 0 / 70%); */\n}\n\n.about .play-btn {\n  width: 94px;\n  height: 94px;\n  background: radial-gradient(var(--primaryColor) 50%, rgba(143, 192, 78, 0.4) 52%);\n  border-radius: 50%;\n  display: block;\n  position: absolute;\n  left: calc(50% - 47px);\n  top: calc(50% - 47px);\n  overflow: hidden;\n}\n\n.about .play-btn::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-40%) translateY(-50%);\n  width: 0;\n  height: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  border-left: 16px solid #fff;\n  z-index: 100;\n  transition: all 400ms cubic-bezier(0.55, 0.055, 0.675, 0.19);\n}\n\n.about .play-btn::before {\n  content: \"\";\n  position: absolute;\n  width: 120px;\n  height: 120px;\n  animation-delay: 0s;\n  animation: pulsate-btn 2s;\n  animation-direction: forwards;\n  animation-iteration-count: infinite;\n  animation-timing-function: steps;\n  opacity: 1;\n  border-radius: 50%;\n  border: 5px solid rgba(143, 192, 78, 0.7);\n  top: -15%;\n  left: -15%;\n  background: rgba(198, 16, 0, 0);\n}\n\n.about .play-btn:hover::after {\n  border-left: 16px solid var(--primaryColor);\n  transform: scale(20);\n}\n\n.about .play-btn:hover::before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-40%) translateY(-50%);\n  width: 0;\n  height: 0;\n  border: none;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  border-left: 16px solid #fff;\n  z-index: 200;\n  animation: none;\n  border-radius: 0;\n}\n\n@keyframes pulsate-btn {\n  0% {\n    transform: scale(0.6, 0.6);\n    opacity: 1;\n  }\n\n  100% {\n    transform: scale(1, 1);\n    opacity: 0;\n  }\n}\n\n.about-border-shadow-left{\n  border-left: 10px solid red;\n  box-shadow: 0 0 20px rgb(151 163 174 / 25%);\n}\n.about-border-shadow-right{\n  border-right: 10px solid red;\n  box-shadow: 0 0 20px rgb(151 163 174 / 25%);\n}\n.about-border-shadow-left h1 {\n  font-size: 2.2em;\n}\n.about-border-shadow-right h1{\n  font-size: 2.2em;\n}\n\n\n@media (max-width: 991.98px){\n  .about-border-shadow-left{\n    border-left: none !important;\n  }\n  .about-border-shadow-right{\n    border-right: none !important;\n  }\n  .about-border-shadow-left h1 {\n    font-size: 1.9em!important;\n  }\n  .about-border-shadow-right h1{\n    font-size: 1.9em!important;\n  }\n  .video-box-first{\n    min-height: 300px;\n  }\n  .video-box-first{\n    min-height: 300px;\n  }\n  .about .icon-box .description{\n    font-size: 18px;\n  }\n}\n\n/*--------------------------------------------------------------\n# Why Us\n--------------------------------------------------------------*/\n.why-us .box {\n  padding: 30px 25px;\n  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.1);\n  transition: all ease-in-out 0.3s;\n  height: 100%;\n}\n\n.why-us .box span {\n  display: block;\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--primaryColor);\n}\n\n.why-us .box h4 {\n  font-size: 24px;\n  font-weight: 600;\n  padding: 0;\n  margin: 20px 0;\n  color: #353535;\n}\n\n.why-us .box p {\n  /* color: #919191; */\n  font-size: 17px;\n  margin: 0;\n  padding: 0;\n}\n\n.why-us .box:hover {\n  background: var(--primaryColor);\n  padding: 20px 20px 60px 20px;\n  box-shadow: 10px 16px 30px rgba(0, 0, 0, 0.18);\n}\n\n.why-us .box:hover span,\n.why-us .box:hover h4,\n.why-us .box:hover p {\n  color: #fff;\n}\n\n/*--------------------------------------------------------------\n# Counts\n--------------------------------------------------------------*/\n.counts {\n  background: #fff;\n  padding: 0 0 60px 0;\n}\n\n.counts .counters span {\n  font-size: 48px;\n  display: block;\n  color: var(--primaryColor);\n}\n\n.counts .counters p {\n  padding: 0;\n  margin: 0 0 20px 0;\n  font-family: \"Archivo\", sans-serif;\n  font-size: 18px;\n}\n\n/*--------------------------------------------------------------\n# Services\n--------------------------------------------------------------*/\n.services .icon-box {\n  text-align: center;\n  border: 1px solid #e5f0d5;\n  padding: 80px 20px;\n  transition: all ease-in-out 0.3s;\n  background: #fff;\n}\n\n.services .icon-box .icon {\n  margin: 0 auto;\n  width: 64px;\n  height: 64px;\n  background: #e49d913b;\n  border-radius: 50px;\n  border: 1px solid #e49d913b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n  transition: ease-in-out 0.3s;\n}\n\n.services .icon-box .icon i {\n  color: #bfdb99;\n  font-size: 28px;\n  transition: ease-in-out 0.3s;\n}\n\n.services .icon-box h4 {\n  font-weight: 700;\n  margin-bottom: 16px;\n  font-size: 24px;\n}\n\n.services .icon-box h4 a {\n  color: #353535;\n  transition: ease-in-out 0.3s;\n}\n\n.services .icon-box p {\n  line-height: 24px;\n  font-size: 18px;\n  margin-bottom: 0;\n}\n\n.services .icon-box:hover {\n  border-color: #fff;\n  box-shadow: 0px 0 25px 0 rgba(0, 0, 0, 0.1);\n}\n\n.services .icon-box:hover h4 a,\n.services .icon-box:hover .icon i {\n  color: var(--primaryColor);\n}\n\n.services .icon-box:hover .icon {\n  border-color: var(--primaryColor);\n}\n\n/*--------------------------------------------------------------\n# Portfolio\n--------------------------------------------------------------*/\n.portfolio {\n  padding-bottom: 40px;\n}\n\n.portfolio #portfolio-flters {\n  padding: 0;\n  margin: 0 auto 25px auto;\n  list-style: none;\n  text-align: center;\n  border-radius: 50px;\n}\n\n.portfolio #portfolio-flters li {\n  cursor: pointer;\n  display: inline-block;\n  padding: 8px 16px 10px 16px;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1;\n  color: #444444;\n  margin: 0 3px 10px 3px;\n  transition: all ease-in-out 0.3s;\n  background: #efefef;\n  border-radius: 50px;\n}\n\n.portfolio #portfolio-flters li:hover,\n.portfolio #portfolio-flters li.filter-active {\n  color: #fff;\n  background: var(--primaryColor);\n}\n\n.portfolio #portfolio-flters li:last-child {\n  margin-right: 0;\n}\n\n.portfolio .portfolio-item {\n  margin-bottom: 30px;\n  overflow: hidden;\n}\n\n.portfolio .portfolio-item img {\n  position: relative;\n  top: 0;\n  transition: all 0.6s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n\n.portfolio .portfolio-item .portfolio-info {\n  opacity: 0;\n  position: absolute;\n  left: 16px;\n  right: 16px;\n  bottom: -50px;\n  z-index: 3;\n  transition: all ease-in-out 0.3s;\n  background: var(--primaryColor);\n  padding: 16px 20px;\n}\n\n.portfolio .portfolio-item .portfolio-info h4 {\n  font-size: 18px;\n  color: #fff;\n  font-weight: 600;\n}\n\n.portfolio .portfolio-item .portfolio-info p {\n  color: #fff;\n  font-size: 18px;\n  margin-bottom: 0;\n}\n\n.portfolio .portfolio-item .portfolio-info .preview-link,\n.portfolio .portfolio-item .portfolio-info .details-link {\n  position: absolute;\n  right: 50px;\n  font-size: 24px;\n  top: calc(50% - 18px);\n  color: white;\n  transition: ease-in-out 0.3s;\n}\n\n.portfolio .portfolio-item .portfolio-info .preview-link:hover,\n.portfolio .portfolio-item .portfolio-info .details-link:hover {\n  color: #e49d913b;\n}\n\n.portfolio .portfolio-item .portfolio-info .details-link {\n  right: 16px;\n}\n\n.portfolio .portfolio-item:hover img {\n  top: -30px;\n}\n\n.portfolio .portfolio-item:hover .portfolio-info {\n  opacity: 1;\n  bottom: 0;\n}\n\n/*--------------------------------------------------------------\n# Team\n--------------------------------------------------------------*/\n.team {\n  background: #fff;\n  padding: 60px 0;\n}\n\n.team .member {\n  margin-bottom: 20px;\n  overflow: hidden;\n  border-radius: 5px;\n  background: #fff;\n  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.1);\n}\n\n.team .member .member-img {\n  position: relative;\n  overflow: hidden;\n}\n\n.team .member .social {\n  position: absolute;\n  left: 0;\n  bottom: 30px;\n  right: 0;\n  opacity: 0;\n  transition: ease-in-out 0.3s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.team .member .social a {\n  transition: color 0.3s;\n  color: #353535;\n  margin: 0 3px;\n  border-radius: 50px;\n  width: 36px;\n  height: 36px;\n  background: var(--primaryColor);\n  display: inline-block;\n  transition: ease-in-out 0.3s;\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.team .member .social a:hover {\n  background: var(--primaryColor);\n}\n\n.team .member .social i {\n  font-size: 18px;\n  line-height: 0;\n}\n\n.team .member .member-info {\n  padding: 25px 16px;\n}\n\n.team .member .member-info h4 {\n  font-weight: 700;\n  margin-bottom: 5px;\n  font-size: 18px;\n  color: #353535;\n}\n\n.team .member .member-info span {\n  display: block;\n  font-size: 13px;\n  font-weight: 400;\n  color: #aaaaaa;\n}\n\n.team .member .member-info p {\n  font-style: italic;\n  font-size: 18px;\n  line-height: 26px;\n  color: #777777;\n}\n\n.team .member:hover .social {\n  opacity: 1;\n  bottom: 16px;\n}\n\n/*--------------------------------------------------------------\n# Contact\n--------------------------------------------------------------*/\n.contact .info {\n  width: 100%;\n  background: #fff;\n}\n\n.contact .info i {\n  font-size: 20px;\n  color: var(--primaryColor);\n  float: left;\n  width: 44px;\n  height: 44px;\n  background: #e49d913b;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50px;\n  transition: all 0.3s ease-in-out;\n}\n\n.contact .info h4 {\n  padding: 0 0 0 60px;\n  font-size: 22px;\n  font-weight: 600;\n  margin-bottom: 5px;\n  color: #353535;\n}\n\n.contact .info p {\n  padding: 0 0 0 60px;\n  margin-bottom: 0;\n  font-size: 18px;\n  color: #686868;\n}\n\n.contact .info .email,\n.contact .info .phone {\n  margin-top: 40px;\n}\n\n.contact .info .email:hover i,\n.contact .info .address:hover i,\n.contact .info .phone:hover i {\n  background: var(--primaryColor);\n  color: #fff;\n}\n\n.contact .php-email-form {\n  width: 100%;\n  background: #fff;\n}\n\n.contact .php-email-form .form-group {\n  padding-bottom: 8px;\n}\n\n.contact .php-email-form .error-message {\n  display: none;\n  color: #fff;\n  background: #ed3c0d;\n  text-align: left;\n  padding: 16px;\n  font-weight: 600;\n}\n\n.contact .php-email-form .error-message br+br {\n  margin-top: 25px;\n}\n\n.contact .php-email-form .sent-message {\n  display: none;\n  color: #fff;\n  background: #18d26e;\n  text-align: center;\n  padding: 16px;\n  font-weight: 600;\n}\n\n.contact .php-email-form .loading {\n  display: none;\n  background: #fff;\n  text-align: center;\n  padding: 16px;\n}\n\n.contact .php-email-form .loading:before {\n  content: \"\";\n  display: inline-block;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  margin: 0 10px -6px 0;\n  border: 3px solid #18d26e;\n  border-top-color: #eee;\n  animation: animate-loading 1s linear infinite;\n}\n\n.contact .php-email-form input,\n.contact .php-email-form textarea {\n  border-radius: 0;\n  box-shadow: none;\n  font-size: 18px;\n}\n\n.contact .php-email-form input {\n  height: 44px;\n}\n\n.contact .php-email-form textarea {\n  padding: 10px 12px;\n}\n\n\n@keyframes animate-loading {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n\n/*--------------------------------------------------------------\n# Footer\n--------------------------------------------------------------*/\n\n.footer-container {\n  background-color: #f8f9fa;\n  padding: 0 0;\n}\n\n.footer-content {\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 20px; \n}\n\n.footer-content > div {\n  flex: 1;\n  margin: 0 10px;\n}\n\n.about-hnh, .info-section, .support-section {\n  margin-bottom: 20px;\n}\n\n.footer-content h3 {\n  margin-top: 0;\n}\n\n.footer-content p {\n  margin-bottom: 10px;\n}\n\n.footer-content a {\n  color: var(--primaryColor);\n}\n\n@media screen and (max-width: 768px) {\n  .footer-content {\n    flex-direction: column;\n  }\n  .about-hnh, .info-section, .support-section {\n    margin-top: 20px;\n  }\n  .footer{\n    height:auto !important;\n  }\n}\n\n.copyright {\n  background-color: #00000040;\n  color: #fff;\n  padding: 10px;\n  text-align: center;\n  border-top: 1px solid var(--primaryColor);\n  clear: both; \n}\n\n\n.footer {\n  background-color: #00000040 !important;\n  color: #fff;\n  padding: 20px;\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  height: 270px;\n}\n\n\n.info-section,\n.support-section {\n  /* flex: 1; */\n  max-width: 400px;\n}\n\n.about-hnh {\n  max-width: 400px;\n}\n\n.footer h2 {\n  margin-bottom: 10px;\n}\n\n.footer p {\n  margin: 0;\n  font-size: 14px;\n}\n\n.accordion-button:not(.collapsed) {\n  background-color: transparent !important;\n  color: var(--primaryColor)!important;\n}\n\n.accordion-button:focus {\n  border-color: none !important;\n  box-shadow:none!important;\n}\n\nbutton.accordion-button {\n  font-size: 20px !important;\n  font-weight: 600 !important;\n}\n\n\n\n#job-listings {\n  padding: 20px;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  border: 1px solid var(--primaryColor);\n  font-size: medium;\n}\n\nth, td {\n  padding: 8px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\n/* JobListing.css */\n\n.table-responsive {\n  overflow-x: auto;\n}\n\n.job-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.job-table th,\n.job-table td {\n  padding: 8px;\n  /* border: 1px solid #ddd; */\n}\n\n.job-table th {\n  background-color: #e49d913b;\n  text-align: left;\n}\n\n.job-table tbody tr:hover {\n  background-color: #ddd;\n}\n\n@media screen and (max-width: 768px) {\n  .job-table {\n    font-size: 16px;\n  }\n}\n\n\n.even-row {\n  background-color: #ffffff;\n}\n\n.odd-row {\n  background-color: #e49d913b;\n}\n\n\n\n/* Define the keyframes for the animation */\n@keyframes fadeInUp {\n  from {\n      opacity: 0;\n      transform: translateY(20px);\n  }\n  to {\n      opacity: 1;\n      transform: translateY(0);\n  }\n}\n\n/* Apply animation to the table */\n.animated-table tbody tr {\n  animation: fadeInUp 0.5s ease-in-out;\n}\n\n/* Add delay to each row for staggered animation */\n.animated-table tbody tr:nth-child(odd) {\n  animation-delay: 0.1s;\n}\n\n.animated-table tbody tr:nth-child(even) {\n  animation-delay: 0.2s;\n}\n\n\n.section-with-title-padding {\n  padding-top: 80px;\n}\n\n.sendbtn:hover{\n  color: white !important;\n  background: rgb(240, 19, 19) !important;\n}\n\n\n/* skills section */\n.skill-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.skill-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.skill-box {\n  flex: 0 0 calc(50% - 20px); \n\n  border: 2px solid #ccc;\n  padding:  2px 0px 2px 0px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.skill-box:hover {\n  /* background-color: #e49d913b; */\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); \n  transform: translateZ(10px); \n}\n\n.skill-box h2 {\n  margin-bottom: 10px;\n}\n\n.modal-overlay {\n  background-color: rgba(0, 0, 0, 0.5);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-content {\n  background-color: #fff!important;\n  color: #000;\n  padding: 20px;\n  border-radius: 10px;\n  max-width: 80%;\n  max-height: 80%;\n  overflow: auto;\n  border-radius: 16px!important;\n}\n\n.modal-close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n}\n\nbody.modal-open {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n\n.modal-content h2 {\n  margin-bottom: 10px;\n}\n\n.modal-content p {\n  margin-bottom: 20px;\n  font-size: 1.2rem;\n}\n\n.modal-content ul {\n  list-style-type: disc;\n  margin-left: 20px;\n  font-size: 1.2rem;\n}\n\n.modal-content ul li {\n  margin-bottom: 5px;\n}\n\n.modal-content button {\n  padding: 10px 20px;\n  background-color: var(--primaryColor);\n  color: white;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.modal-content button:hover {\n  background-color: #a01707;\n}\n\n.additional-info {\n  display: flex;\n  justify-content: space-between;\n}\n\n@media screen and (max-width: 768px) {\n  .skill-box {\n    flex: 0 0 calc(100% - 10px); \n    margin: 0px;\n    padding: 2px;\n  }\n  \n  .modal-content {\n    width: 90%; \n  }\n}\n\n@media screen and (max-width: 480px) {\n  .skill-box {\n    flex: 0 0 calc(100% - 10px); \n    margin: -5px 2px;\n    padding: 2px 0px 2px;\n  }\n}\n\n.tabs-container {\n  display: flex;\n  justify-content: space-between;\n  max-width: 1333px; \n  margin: 0 auto; \n  display: flex;\n}\n\n.tabs-sidebar {\n  flex: 0 0 calc(25% - 20px); \n  padding: 20px;\n}\n\n\n.tabs-content {\n  flex: 1;\n  padding: 20px;\n  display: flex;\n  flex-direction: row; \n  flex-wrap: wrap; \n}\n\n\n@media (max-width: 767.98px) {\n  .tabs-content {\n    flex-direction: column;\n  }\n}\n\n\n.tabs-content .content-box > div {\n  flex: 0 0 calc(50% - 20px); \n}\n\n@media (min-width: 768px) {\n  .tabs-content .content-box > div {\n    flex: 0 0 calc(33.33% - 20px); \n  }\n  \n}\n.content-box h2 {\n  color: var(--primaryColor);\n  font-weight: 600;\n}\n\n.tabs-sidebar .cursor-pointer {\n  transition: background-color 0.3s ease;\n  padding: 8px 16px;\n  font-size: 1.3rem;\n}\n\n.tabs-sidebar .cursor-pointer:hover {\n  background-color: #f0f0f0;\n  font-weight: 600;\n}\n\n\n@media (max-width: 768px) {\n  .tabs-container {\n    flex-direction: column;\n  }\n\n  .tabs-sidebar {\n    flex: 1;\n  }\n  .tabs-sidebar .cursor-pointer {\n    transition: background-color 0.3s ease;\n    padding: 1px 10px;\n    font-size: 1.1rem;\n    margin: 0px;\n  }\n  \n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n\n/* .tabs-sidebar .cursor-pointer {\n  transition: background-color 0.3s ease;\n  padding: 8px 16px;\n}\n\n.tabs-sidebar .cursor-pointer:hover {\n  background-color: #f0f0f0;\n} */\n\n.tabs-sidebar .cursor-pointer.active {\n  background-color: #e49d913b;\n  color: black;\n  font-weight: 600;\n}\n\n.tab-sideBorder {\n  border-left: 3px solid black;\n}\n\n.content-flex-dynamic {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n\n@media (max-width: 767.98px) {\n  .content-flex-dynamic {\n    flex-direction: column;\n  }\n\n}\n\n.hover-effect:hover {\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); \n  transform: translateZ(10px); \n}\n\n\n@media screen and (max-width: 768px) {\n  .responsive-container {\n    flex-direction: column;\n    width: 100%!important; \n    margin-right: 0;\n  }\n  .navbar a {\n    padding: 10px !important;\n  }\n}\n\n\n/* ProjecSteps */\n\n.box-steps {\n  border: 1px solid #000;\n  padding: 10px;\n  margin-bottom: 10px;\n}\n\n/* .connector {\n  border-left: 2px solid #000;\n  height: 100px;\n  margin-left: 20px;\n  margin-right: 20px;\n} */\n\n\n/* .box-card {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  margin-bottom: 0; \n  opacity: 0.9;\n}\n.img-fluid-card {\n  max-width: 100%;\n  height: auto;\n  display: block;\n  transition: transform 0.5s ease, opacity 0.5s ease;\n} */\n\n.img-fluid-card {\n  width: calc(2 * var(--height)); \n  /* width: 200px !important; */\n  height: 100%; \n  max-width: 100%; \n  max-height: 100%; \n  object-fit: cover; \n  display: block;\n  transition: transform 0.5s ease, opacity 0.5s ease;\n  filter: brightness(75%);\n}\n.heading {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  color: white;\n  z-index: 1;\n  /* margin-bottom: 10px; */\n}\n\n.box-card {\n  --height: 200px; \n  position: relative;\n  overflow: hidden;\n  width: calc(2 * var(--height)); \n  /* width: 30rem; */\n  /* height: var(--height);  */\n  height: 500px;\n  margin-bottom: 0; \n  /* border-bottom-left-radius: 5rem;\n  border-top-right-radius: 5rem; */\n  /* border-radius: 25px; */\n}\n\n.box-card-content {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  /* display: flex;\n  justify-content: center;\n  align-items: center; */\n  transition: all 0.5s ease-in-out;\n}\n\n.box-card-content h2{\n  font-size: 30px;\n  transition: all 0.5s ease-in-out;\n}\n.box-card-content h3 {\n  font-size: 30px;\n  transition: all 0.5s ease-in-out;\n}\n.box-card-content:hover{\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.box-card-content:hover h2, .box-card-content:hover h3 {\n  font-size: 30px;\n  /* top: 10px;\n  left: 10px; */\n  padding: 10px;\n}\n\n.overlay-card {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  /* background: linear-gradient(275deg, red, black); */\n  opacity: 0.2;\n  transition: opacity 0.5s ease;\n}\n\n.card-color-violet {\n  background: #6F0673;\n  background: linear-gradient(315deg, #6F0673, #010101);\n}\n.card-color-red {\n  background: linear-gradient(120deg, rgb(21 20 22) 23%, rgb(55 6 6) 40%, rgba(249,0,0,1) 120%);\n}\n.card-color-black {\n  background: linear-gradient(120deg, rgba(21,20,22,1) 0%, rgba(0,0,0,1) 56%, rgba(249,0,0,1) 100%);\n}\n@media (hover: hover) {\n  /* No styles needed for devices with hover capability */\n}\n\n@media (hover: none) and (pointer: coarse) {\n  .box-card-content .hidden-paragraph {\n    /* position: relative; */\n    z-index: 1;\n    color: white;\n    /* text-align: center; */\n    margin: 0;\n    padding: 0px;\n    font-size: 20px;\n    /* background-color: rgba(0, 0, 0, 0.5); */\n    width: calc(100% - 40px);\n    transform: translate(-50%, -50%);\n    top: 55%;\n    left: 50%;\n    opacity: 1;\n    transition: opacity 0.5s ease;\n  }\n  .box-card-content h2 {\n    padding: 0px;\n    font-size: 25px!important;\n  }\n  .box-card-content h3 {\n    padding-left: 0px;\n    font-size: 30px!important;\n  }\n  /* .box-card-content{\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n  } */\n  .overlay-card{\n    opacity: 0.7;\n  }\n}\n\n\n.box-card:hover .img-fluid-card {\n  transform: translateX(-100%);\n  opacity: 0;\n}\n\n.box-card:hover .overlay-card {\n  opacity: 0.9;\n}\n\n.hidden-paragraph {\n  position: absolute;\n  top: 50%;\n  right: -100%;\n  width: 87%;\n  transform: translateY(-50%);\n  color: white;\n  transition: right 0.5s ease;\n}\n\n.box-card:hover .hidden-paragraph {\n  margin: 20px;\n  right: 0px;\n}\n\n\n\n\n/* Statistics */\n.red {\n  color: red;\n}\n\n.vertical-line {\n  width: 2px;\n  background-color: red;\n  height: 80px; \n}\n\n.icon-and-line {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n@media (max-width: 576px) { \n  .icon-and-line {\n    flex-direction: row; \n    justify-content: center; \n    margin-bottom: 20px; \n  }\n  \n  .icon-and-line .vertical-line {\n    display: none; /* Hide vertical lines on mobile */\n  }\n}\n\n/* Our Project */\n.yellow-background {\n  background-color: rgb(195 195 195);\n}\n\n.violet-background {\n  background-color: #ff000029;\n}\n\n.orange-background {\n  background-color: rgb(249 118 1 / 29%);\n}\n.blue-background{\n  background-color: rgb(0 6 255 / 18%)\n}\n\n\n/* .section-with-background:before {\n  content: \"\";\n  background-image: url(https://www.solulab.com/wp-content/themes/Avada-Child-Theme/images/dot-bg.png);\n  position: absolute;\n  left: 0;\n  top: 100px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100%;\n  width: 100%;\n} */\n\n.section-with-background {\n  background-image: url(https://www.solulab.com/wp-content/themes/Avada-Child-Theme/images/dot-bg.png);\n  background-size: cover;\n}\n\n.left-section-border {\n  border-top-right-radius: 65px;\n  border-bottom-right-radius: 65px;\n  border: 1px solid red;\n  border-top-left-radius: 12px;\n  border-bottom-left-radius: 12px;\n}\n\n.right-section-border {\n  border-top-left-radius: 65px;\n  border-bottom-left-radius: 65px;\n  border-top-right-radius: 12px;\n  border-bottom-right-radius: 12px;\n  border: 1px solid red;\n}\n\n.icon-border {\n  border: 1px solid red;\n    border-radius: 50%;\n    padding: 1.2rem;\n    color: red;\n    border-bottom-width: medium;\n}\n\n.arrow {\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  bottom: 10px;\n  z-index: 1;\n  background-color: rgb(221, 128, 128); \n}\n\n.arrow-left {\n  left: 10px;\n}\n\n.arrow-right {\n  right: 10px;\n}\n\n.arrow::before {\n  content: '';\n  display: block;\n  width: 20px;\n  height: 20px;\n  background-color: rgb(226, 128, 128); \n  position: absolute;\n  bottom: 0;\n  right: 0;\n  transform: rotate(45deg); \n}\n\n\n/* .arrow-container {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  transform: translate(50%, 50%) rotate(45deg);\n} */\n\n.dot-icon {\n  color: rgb(254, 122, 122); \n  font-size: 24px; \n  margin-right: 5px; \n}\n\n.arrow-container {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  transform: translate(-50%, 50%);\n}\n\n.arrow-container {\n  width: 0px; \n  height: 0px; \n}\n\n.arrow-icon {\n  color: rgb(254, 122, 122); \n  font-size: 26px; \n  transform: scaleX(2); \n\n}\n\n@media (max-width: 991.98px) {\n  .arrow-container {\n    display: none;\n  }\n}\n\n.rounded-10 {\n  border-radius: 10px;\n}\n\n@media (max-width: 775px) {\n  .rounded-10 {\n      border-radius: 20px;\n  }\n}\n\n/* .left-arrow {\n  left: 0;\n  transform: rotate(135deg);\n}\n\n.right-arrow {\n  right: 0;\n  transform: rotate(45deg);\n} */\n\n.left-arrow {\n  left: 0px;\n  transform: rotate(135deg);\n}\n\n.right-arrow {\n  right: 0px;\n  transform: rotate(45deg);\n}\n\n@media only screen and (max-width: 1200px) {\n  .left-arrow {\n    left: 0px;\n    transform: rotate(135deg);\n  }\n  \n  .right-arrow {\n    right: 0px;\n    bottom: 4px;\n    transform: rotate(45deg);\n  }\n}\n\n@media only screen and (max-width: 900px) {\n  .left-arrow {\n    /* left: -30px; */\n    transform: rotate(135deg);\n  }\n  \n  .right-arrow {\n    /* right: -30px; */\n    transform: rotate(45deg);\n  }\n}\n\n.custom-icon:hover .arrow-icon,\n.custom-icon:hover .dot-icon {\n  color: red;\n}\n.custom-icon:hover .icon-border{\n  color: white;\n  background-color: red;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n.darksoul-gradient-card3 {\n  background: linear-gradient(var(--gradient-angle), rgb(255, 16, 3), rgb(0, 0, 0), rgb(250, 81, 58), rgb(0, 0, 0));\n  border-radius: 5px;\n  animation: rotation 5s linear 0s infinite normal forwards;\n  backdrop-filter: blur(50px);\n}\n\n.darksoul-content-card {\n  background-color: white;\n  border-radius: 5px;\n  transition: all 0.2s;\n  backdrop-filter: blur(5px);\n  display: flex;\n  flex-direction: row;\n}\n\n.darksoul-content-card h2 {\n  /* font-family: 'Archivo', sans-serif; */\n  color: black;\n  /* font-size: 20px; */\n  margin: auto;\n  font-weight: 100;\n}\n\n.darksoul-content-card p {\n  font-family: 'Archivo', sans-serif;\n  color: black;\n  font-size: 16px;\n}\n\n.skill-box {\n  transition: box-shadow 0.3s ease-in-out; \n}\n\n.skill-box:hover {\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); \n}\n\n@keyframes rotation {\n  0% {\n    --gradient-angle: 0deg;\n  }\n  100% {\n    --gradient-angle: 360deg;\n  }\n}\n\n@property --gradient-angle {\n  syntax: \"<angle>\";\n  initial-value: 0deg;\n  inherits: false;\n}\n\n\n\n\n.application-form-container {\n  max-width: 500px;\n  margin: 0 auto;\n  padding: 20px;\n  /* background-color: white !important; */\n  border-radius: 10px;\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);\n}\n\n.application-form-container h2 {\n  margin-bottom: 20px;\n}\n\n.application-form-container .form-control {\n  margin-bottom: 15px;\n}\n\n.application-form-container .btn {\n  width: 100%;\n}\n\n\n\n\n\n.card {\n  transition: box-shadow 0.3s;\n}\n\n.card:hover {\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n}\n\n.card-img-top {\n  object-fit: cover;\n  height: 200px;\n}\n\n\n\n/* case-study */\n.heading-size{\n  font-size: 40px !important;\n}\n\n.prev-icon, .next-icon {\n  color: black;\n  font-size: 18px;\n  font-weight: 600;\n  text-shadow: 0 0 10px rgba(0, 0, 0, 0.3); \n  text-decoration: none;\n}\n\n.prev-icon:hover, .next-icon:hover {\n  color: red;\n  text-shadow: 0 0 10px rgba(0, 0, 0, 0.3); \n}\n.prev-icon .border:hover, .next-icon .border:hover {\n  color: red;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3); \n}\n\n\n\n/* \nParallax styles\n*/\n.parallax {\n  min-height: 35vh; \n  background-attachment: fixed;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size:cover;\n  \n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative; \n}\n.about-img {\n  /* background-image: url(\"../img/about/BG10.jpg\"); */\n    background: \n    linear-gradient(90deg, rgb(3 10 9/50%), rgb(255 0 0 / 50%)),\n    url(\"../img/about/BG30.jpg\") center/cover fixed; \n}\n.service-img {\n  /* background-image: url(\"../img/about/BG12.jpg\"); */\n  background: \n  linear-gradient(125deg, rgb(3 10 9/50%), rgb(255 0 0 / 25%)),\n  url(\"../img/service/BG3.jpg\") center/cover fixed; \n}\n.case-study-img {\n  background-image: url(\"../img/footer-bg.jpg\");\n}\n.techno-img {\n  /* background-image: url(\"../img/about/BG14.jpg\"); */\n  background: \n  linear-gradient(125deg, rgb(3 10 9/50%), rgb(255 0 0 / 50%)),\n  url(\"../img/service/BG21.jpg\") center/cover fixed; \n}\n.career-img {\n  /* background-image: url(\"../img/career/career.png\"); */\n  background: \n  linear-gradient(90deg, rgb(3 10 9/70%), rgb(255 0 0 / 60%)),\n  url(\"../img/career/career.png\") center/cover fixed; \n}\n.contact-img {\n  /* background-image: url(\"../img/contact/contact.jpg\"); */\n  background: \n  linear-gradient(90deg, rgb(3 10 9/30%), rgb(255 0 0 / 40%)),\n  url(\"../img/contact/contact.jpg\") center/cover fixed; \n}\n\n.logo-img {\n  background-image: url(\"../img/hnh-logo.png\");\n}\n\n\n.parallax-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5); \n}\n\n.parallax h1 {\n  color: white; \n  position: relative; \n  z-index: 1; \n  font-size: 4em;\n  font-weight: 600;\n  text-align: center;\n}\n\n/* Footer */\n\n.footer-container {\n  position: relative;\n  background-image: url(\"../img/footer-bg.jpg\");\n  background-size: cover;\n  background-position: center;\n  min-height: 365px; \n  background-attachment: fixed;\n\n}\n\n.footer-content {\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 1200px; \n}\n\n.about-hnh {\n  /* text-align: center; */\n}\n\n.social {\n  margin-top: 20px;\n}\n\n.info-section,\n.support-section {\n  color: white;\n}\n\n.info-section p,\n.support-section p {\n  margin-bottom: 10px;\n}\n\n.footer-container .copyright {\n  /* position: absolute; */\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  /* padding: 20px; */\n  text-align: center;\n}\n\n.parallax-section {\n  position: relative;\n  overflow: hidden;\n}\n\n.Toastify__toast-container--top-right{\n  top: 15%!important;\n}\n\n\n\n/* error */\n.error-container {\n  text-align: center;\n  margin-top: 100px;\n}\n\n.error-image {\n  max-width: 300px;\n  margin-bottom: 30px;\n}\n\n.error-heading {\n  font-size: 36px;\n  color: #343a40;\n  margin-bottom: 20px;\n}\n\n.error-message {\n  font-size: 18px;\n  color: #6c757d;\n  margin-bottom: 20px;\n}\n/* error */\n\n\n.circle {\n  width: 150px;\n  height: 150px;\n  /* border-radius: 50%; */\n  overflow: hidden;\n  margin: 0 auto;\n}\n\n.circle .rounded-circle {\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: center;\n}\n.edit-icon {\n  position: absolute;\n  bottom: 5px;\n  right: 5px;\n  font-size: 1.2rem;\n  color: #fff;\n  cursor: pointer;\n  background-color: black;\n  padding: 10px;\n  border-radius: 50%;\n}\n\n\n\n\n\n\n/* Employee Handbook */\n.auth-card{\n  padding: 20px;\n  text-align: center;\n  max-width: 400px;\n  margin: 10% auto;\n  box-shadow: 2px 10px 18px 2px rgb(230, 173, 173)\n}\n\n.modal-background {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5); \n  z-index: 1040; \n}\n\n\ninput.form-control, select, textarea{\n  box-shadow: none!important;\n}\n\n\n.no-hover-card:hover {\n  box-shadow: none;\n}\n\n@media only screen and (max-width: 991px) {\n  span.hidetext{\n    display: none!important;\n  }\n  .showrow{\n    display: flex;\n  }\n  .center-icon{\n    justify-content: center;\n  }\n  .icon-size{\n    font-size: 20px;\n    padding: 0px;\n    margin: 0px;\n  }\n  .nav-link{\n    padding: 10px;\n  }\n}\n\n\n.sticky-sidebar{\n  position: sticky;\n  top: 50px;\n  background: white;\n  z-index: 999;\n}\n\n/* Custom CSS for the modal */\n.custom-modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 50%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(5px);\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  z-index: 1050;\n  justify-content: center;\n}\n\n.modal-content {\n  width: 100%;\n  max-width: 98%;\n  max-height: 90%;\n  background-color: white;\n  border-radius: 10px;\n  overflow: auto;\n  /* animation: slideIn 0.5s forwards; */\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n/* attendance */\n.center-line {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  z-index:-1;\n}\n\n/* Announcement skeleton */\n.skeleton-card {\n  background-color: #f0f0f0;\n  height: 80px; \n  border-radius: 8px;\n  position: relative;\n  overflow: hidden;\n}\n\n.skeleton-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent);\n  animation: shimmer 1s infinite;\n}\n\n@keyframes shimmer {\n  100% {\n    left: 100%;\n  }\n}\n/* Announcement skeleton */\n\n.form-control-announce {\n  width: 100%;\n  padding: 2px;\n  border: none;\n  border-radius: 0;\n  border-bottom: 2px solid #0058b1;\n  padding: 0.5rem 0;\n}\n\n.form-control-announce {\n  /* border-color: #ced4da; */\n  border-color: #ced4da61;\n  transition: border-color 0.5s ease-in-out;\n  font-size: 15.6px;\n}\n\n.form-control-announce:focus,\n.form-control-announce:hover {\n  border-bottom: 2px solid rgb(102, 102, 247);\n  outline: none;\n}\n\n@keyframes borderAnimation {\n  0% {\n    background-position: 0 0;\n  }\n  100% {\n    background-position: 100% 0;\n  }\n}\n\n.form-control-announce:focus,\n.form-control-announce:hover {\n  animation: borderAnimation 1s forwards;\n}\n\n#border-in-table {\n  border: 1px solid;\n  width: 20% !important;\n  /* border-bottom: none !important; */\n  margin: 0 auto !important;\n  z-index: 12 !important;\n}\n\n@media (max-width: 767px) {\n  #border-in-table {\n    width: 100% !important;\n  }\n}\n\n\n\n.font-title {\n  font-size: 19px;\n}\n.font-sub-title {\n  font-size: 16px;\n}\n.font-content {\n  font-size: 13px;\n}\n\n\n\n/* Image */\n.circle-image {\n  width: 10px;\n  height: 10px;\n  /* overflow: hidden; */\n  border-radius: 10%;\n}\n\n.bullet {\n  color: #dc3545;\n  margin-right: 0.5rem;\n}\n\n.submenu {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.3s ease-out;\n}\n\n.submenu.open {\n  max-height: 100px;\n}\n\n\n/* SideNavbar.css */\n\n/* .icon-size {\n  font-size: 1.5em;\n} */\n\n.sidebar:hover .hidetext {\n  display: inline;\n}\n\n.submenu {\n  display: none;\n}\n\n.submenu.open {\n  display: block;\n}\n\n.nav-link {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.badge {\n  font-size: 0.75em;\n  margin-left: 5px;\n}\n\n.position-sticky {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n}\n\n@media (max-width: 992px) {\n  .sidebar {\n    display: none;\n  }\n  \n  .sidebar-offcanvas .nav-link {\n    display: flex;\n    align-items: center;\n  }\n\n  .hidetext {\n    display: inline;\n  }\n}\n\n@media (max-width: 768px) {\n  .sidebar {\n    width: 60px;\n  }\n\n  .sidebar:hover {\n    width: 150px;\n  }\n}\n\n.offcanvas-custom {\n  width: 50%;\n}\n\n.offcanvas-backdrop-custom {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1040;\n  display: none;\n}\n\n.offcanvas-backdrop-custom.show {\n  display: block;\n}\n\n.form16-table tbody > tr > td {\n  font-size: 13px;\n}\n\n.navbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.navbar-collapse {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.navbar-nav {\n  display: flex;\n}\n\n.navbar-toggler {\n  display: none; \n}\n\n@media (max-width: 991px) {\n  .navbar-collapse {\n    flex-direction: column;\n    overflow: hidden;\n    transition: max-height 0.35s ease, opacity 0.35s ease;\n    max-height: 0;\n    opacity: 0;\n  }\n\n  .navbar-collapse.show {\n    max-height: 500px;\n    opacity: 1;\n  }\n\n  .navbar-toggler {\n    display: block;\n  }\n\n  .navbar-nav {\n    display: flex;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
